import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { SWAlertService } from '../../services/swalert.service';
import { BusinessDayService } from '../../services/business-day.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker/public_api';
import { promise } from 'protractor';
import { isNullOrUndefined } from 'util';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/ngx-bootstrap-typeahead';
import Swal from 'sweetalert2';
import { async } from 'rxjs/internal/scheduler/async';
import { math, Validatable } from '@amcharts/amcharts4/core';
import { ASTWithSource } from '@angular/compiler';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpEventType, HttpParams } from '@angular/common/http';
import { Observable, Subject, merge, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, debounce } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { Router, Data, ActivatedRoute } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
declare var ArrFile: any[];
declare var Uploadfiles, Clearuploadfile, SetData, _Path, Extension: any, Accept: any
@Component({
  selector: 'app-cntype',
  templateUrl: './cntype.component.html',
  styleUrls: ['./cntype.component.css'],
  providers: [DatePipe, TSFuntionService, DecimalPipe]
})
export class CNTypeComponent implements OnInit {
  nReqUrgentDay: any;
  olddate: any = "";
  IsNotFill_IO = false;
  isNew: boolean = true;
  isThai: boolean = true;
  ResultPermission: boolean;
  isSubmit: boolean = false;
  haveRequestCode: boolean = false;
  haveComments: boolean = true;
  isUseIo: boolean = false;
  sReqID: any;
  IsReqUrgent: boolean = false;
  IsLoadingBankAll: boolean = false;
  isDraft: boolean = false;
  isReject: boolean = false;
  IsNotFill_GL = false;
  IsVendorOneTime: boolean = false;
  myFiles: string[] = [];
  sMsg: string = '';
  VendorCodemaxLength: any = 40;
  sComment: string = "";
  sCommentSSC: string = "";
  ArrTransactionHistory: Array<any> = [];

  bg_color: string = '';
  isUseGL: boolean = false;
  EditInvoiceCode: any;
  EditInvoiceDate: any;
  sReqCode: any;
  nEditindex: any;
  isEdit: boolean;
  isPrint: boolean = false;
  isEditFromhome: boolean = false;
  isNewRequest: boolean = false;
  isForROS: boolean = false;
  //NoResults
  isCountryNoResult: any = false;
  sAmphorNoResult: any = false;
  TypeNoResult: any;
  CopyNoResult: any;
  GlNoResult: any[] = [];
  Approve1NoResult: any;
  sTumbonNoResult: any = false;
  sSubDistrictNoResult: any = false;
  CostCenterNoResult: any[] = [];
  IONoResult: any[] = [];
  BankNoResult: any;
  BankNoResult2: any;
  Approve2NoResult: any;
  //
  clicked: boolean  = false;
  name: string;
  vendorcode: string;
  sGL: string;
  hBank: boolean;
  nCostCenterCode: any;
  sCostcen: any;
  message: string;
  messagebank: string = " ";
  hVatAmount: boolean;
  hidbankother: boolean;
  nComcode: any;
  DataVendor: any;
  DataGL: any;
  DataCostCenter: any;
  DataIO: any;
  DataApprover: any;
  DataBusinessArea: any;
  hBranch: boolean;
  ArrIO: any[] = [];
  Currency: any;
  Currencys: any;
  ArrMaster: Array<any> = [];
  DataEmployee: any;
  WHT: any;
  today: number = Date.now();
  Bank: any;
  VatType: any;
  TM_Config: any;
  maxDateinvoice: Date;
  dToday = this.datepipe.transform(this.today, 'dd/MM/yyyy')
  TODAY: Date;
  toDay: Date;
  DataRequest: any;
  maxDate: Date;
  sArrGL: any[] = [];
  ArrCostCenter: any[] = [];
  ArrApprover: any[] = [];
  DataBankBranch: any;
  GetApprover: any;
  DataBankBranch2: any;
  masterDataBankBranch2: any;
  ArrEmployee: any[] = [];

  todayy: any;
  masterDataBankBranch: any;
  holidays: Date[]; //ตัวแปรรับค่า holiday
  bsConfig: Partial<BsDatepickerConfig>; //Set congic datepicker เท่านั้น ส่วน daterangpicker จะใช้อีก confic หนึ่ง
  Settodate: Date;
  _HolidayDB = [];
  paytoCNForm: FormGroup;
  get _paytoCNForm() { return this.paytoCNForm.controls; }
  get ArrGL() { return this._paytoCNForm.ArrGL as FormArray; }//Dynamic
  ArrInvoicelength: any;
  ArrRequest: any[] = [];
  ArrRequestCN: Array<any> = [];
  ArrVendor: any[] = [];
  _ArrCountry: any;
  ArrVendorName: any[] = [];
  _ArrProvince: any;
  _ArrAmphur: any;
  _ArrTumbon: any;
  fileType: any;
  limit: any;
  urgentDay: number = 6;
  FieldOnetimeValid: any[] = [
    { _Field: "sAmpName", _Validator: Validators.required, _Value: "" },
    { _Field: "txtCountryID", _Validator: Validators.required, _Value: "ประเทศไทย (Thailand)" },
    { _Field: "sProvCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sProvName", _Validator: Validators.required, _Value: "" },
    { _Field: "sTumbonCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sCountryID", _Validator: Validators.required, _Value: "213" },
    { _Field: "sTumbonName", _Validator: Validators.required, _Value: "" },
    { _Field: "sPostCode", _Validator: null, _Value: "" },
    { _Field: "sPhoneNumber", _Validator: null, _Value: "" },
    { _Field: "sFaxNumber", _Validator: null, _Value: "" },
    { _Field: "sAmpCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sVendorEmail", _Validator: Validators.email, _Value: "" },
  ];
  constructor(private http: HttpClient, private formBuilder: FormBuilder, public datepipe: DatePipe, private SW: SWAlertService, private BusinessDay: BusinessDayService, private _decimalPipe: DecimalPipe, private System: TSFuntionService, private activatedRoute: ActivatedRoute, private router: Router) { }

  async ngOnInit() {
    this.ArrMaster[0] = [];
    this.isEdit = false;
    this.maxDate = new Date();
    this.maxDateinvoice = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 1)
    this.TODAY = new Date();
    this.toDay = new Date();
    this.hBranch = true;
    await this.http.get<any>("api/Autocomplete/TM_Holiday/*").toPromise().then(res => {
      if (res) {
        this._HolidayDB = res.filter(f => f.IsDelete == false && f.cActive == "Y");
      }
      this.holidays = this._HolidayDB.map(({ dDate }) => new Date(dDate))
    })
    this.hBank = false;
    this.SetFormCN();
    this.bsConfig = Object.assign({}, {
      containerClass: 'theme-dark-blue' //set theme
      , dateInputFormat: 'DD/MM/YYYY' //set Format
      , showWeekNumbers: false
      , datesDisabled: this.holidays //set holidays (type Date only)
      , daysDisabled: [0, 6]
    });
    this._ArrAmphur = [];

    this.Settodate = this.BusinessDay.SetToday(this.holidays);
    this.TODAY = this.BusinessDay.SetToday(this.holidays);
    this.TODAY.setDate(this.TODAY.getDate() + 1);
    this.TODAY = this.BusinessDay.SetNextDate(this.TODAY, this.holidays);
    this._ArrTumbon = [];
    let ua = this.System.GetUserStorage();
    this.System.BlockUI();
    this.paytoCNForm.patchValue({ dDueDate: this.TODAY });
    this.nComcode = ua.sCompCode;
    await this.GetAutocomplete();
    this.activatedRoute.queryParams.subscribe(async params => {
      let ID: string = this.System.GetQuerySTR('str');
      let ID2: string = this.System.GetQuerySTR('ros');
      this.sReqID = await this.System.Decrypt(ID);
      if (ID2 !== 'undefined') {
        this.sReqID = await this.System.Decrypt(ID2);
        this.isForROS = true;
        this.urgentDay = 8;
      }
      if(this.sReqID === ''){
        this.isNewRequest = true;
      }
      this.Edit(this.sReqID);
    });
    this.hidbankother = ua.sCompCode != 396;
    await this.getFileType();
    await this.getFileLimit();
    var setUp1 = {
      sID: "dvFile",
      nFileSize: 15,
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true,
      ArrFile: ArrFile,
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limit
    };
    this.hVatAmount = false;
    this.paytoCNForm.controls['sBranch'].disable();
    this.paytoCNForm.controls['BankOther'].disable();
    this.paytoCNForm.controls['sVendorName'].disable();
    this.paytoCNForm.controls['sAddress'].disable();
    this.today = this.BusinessDay.SetToday(this.holidays).getTime();
    this.dToday = this.datepipe.transform(this.today, 'dd/MM/yyyy')
    this.paytoCNForm.controls['sTAXID'].disable();
    this.paytoCNForm.controls['ddBankKey2'].disable();
    this.paytoCNForm.controls['nWHTOther'].disable();
    this.paytoCNForm.controls['nWHTOther2'].disable();
    this.checkUseIo();
    this.checkUseGL();
    let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, this.TODAY, this.holidays);
    this.message = (check_date < this.urgentDay && this.isSubmit != true) ? 'You have ' + check_date + ' working days before due date. This is "Urgent" payment' : "";
    this.nReqUrgentDay = check_date;
    this.IsReqUrgent = check_date < this.urgentDay ? true : false;

    Uploadfiles(setUp1);
    Clearuploadfile();
  }
  async Reject() {
    let _thisCN = this;
    let sComment = _thisCN.paytoCNForm.get('sComment').value;
    if (sComment === null || sComment === "") {
      _thisCN.SW.SwAlert.Error(_thisCN.SW.BoxMsg.Title_Error, _thisCN.SW.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else{
      let DataSave = {
        TRequest: {
          sRequestID: _thisCN.paytoCNForm.get('sRequestID').value,
          sComment: sComment,
        },
      }
      let Data = JSON.stringify(DataSave)
      let save = function () {
        _thisCN.System.BlockUI();
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _thisCN.http.post(_thisCN.System.SiteName + "api/ROService/Reject", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            ArrFile = [];
            _thisCN.System.UnBlockUI();
            _thisCN.SW.SwAlert.Success(_thisCN.SW.BoxMsg.Title_Success, _thisCN.SW.BoxMsg.Desc_SaveComplete, function () { _thisCN.router.navigate(["ro-service"]) });
          } else {
            _thisCN.System.UnBlockUI();
          }
        });
      }
      _thisCN.SW.SwAlert.Confirm(_thisCN.SW.BoxMsg.Title_Confirm, _thisCN.SW.BoxMsg.Desc_Confirm_Submit, save, function () { });
    }
  }
  checkFile() {
    if (ArrFile.filter(f => f.IsDelete === false).length > 0) {
      const chkFile =  document.getElementById('dv_dvFile');
      chkFile.style.border = '1px solid #dde4f6';
    }
    return '';
  }
  async getFileType() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileType').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        if (data[x]['sValue'] === 'Y') {
          result.push(data[x]['sValueText']);
        }
      }
      this.fileType = result;
    });
  }
  async getFileLimit() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileLimit').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        result.push(data[x]['sValue']);
      }
      this.limit = result;
    });
  }
  setVat() {
    let _thisCN = this;
    let vatType = this.paytoCNForm.value.ddVatType;
    if (vatType != "-1") {
      let datavat = this.VatType.filter(s => s.TAX_CODE == vatType)[0]
      this.hVatAmount = datavat.TAX_CODE == "VZ" ? true : false;

      this.paytoCNForm.patchValue({ nVat: datavat.nVAT });
      if (this.hVatAmount == true) {
        _thisCN.paytoCNForm.controls.nVatAmount.setValidators([]);
        _thisCN.paytoCNForm.controls.nVatAmount.setErrors(null);
        _thisCN.paytoCNForm.controls.nVatAmount.updateValueAndValidity();
        _thisCN.paytoCNForm.controls.nVatAmount.disable();
        _thisCN.paytoCNForm.controls.nVatAmount.clearValidators();
        _thisCN.paytoCNForm.controls.nVatAmount.markAsUntouched({ onlySelf: true });
        _thisCN.calVat();
        _thisCN.paytoCNForm.patchValue({
          nVatAmount: null,
        });
      } else if (this.hVatAmount == false) {
        _thisCN.paytoCNForm.controls["nVatAmount"].setValidators([Validators.required]);
        _thisCN.calVat();
        _thisCN.paytoCNForm.controls["nVatAmount"].updateValueAndValidity();
        _thisCN.paytoCNForm.controls["nVatAmount"].clearValidators();
        _thisCN.paytoCNForm.controls.nVatAmount.enable();
      }

    }
  }
  Editsetvat() {
    let vatTypeCN = this.paytoCNForm.value.ddVatType;
    let _thisCN = this;
    if (vatTypeCN != "-1") {
      let datavatCN = { nVAT: '', TAX_CODE: '' };
      if (this.VatType.filter(s => s.TAX_CODE == vatTypeCN).length > 0) {
        datavatCN = this.VatType.filter(s => s.TAX_CODE == vatTypeCN)[0]
        this.paytoCNForm.patchValue({ nVat: datavatCN.nVAT });
        this.hVatAmount = datavatCN.TAX_CODE == "VZ" ? true : false;
      }
      
      this.paytoCNForm.patchValue({ nVat: datavatCN.nVAT });
      if (this.hVatAmount == true) {
        _thisCN.paytoCNForm.controls.nVatAmount.setErrors(null);
        _thisCN.paytoCNForm.controls.nVatAmount.updateValueAndValidity();
        _thisCN.paytoCNForm.controls.nVatAmount.disable();
        _thisCN.paytoCNForm.controls.nVatAmount.clearValidators();
        _thisCN.paytoCNForm.controls.nVatAmount.markAsUntouched({ onlySelf: true });
        _thisCN.paytoCNForm.controls.nVatAmount.setValidators([]);
        _thisCN.paytoCNForm.patchValue({
          nVatAmount: null,
        });
      } else if (this.hVatAmount == false) {
        _thisCN.paytoCNForm.controls["nVatAmount"].setValidators([Validators.required]);
        _thisCN.paytoCNForm.controls["nVatAmount"].updateValueAndValidity();
        _thisCN.paytoCNForm.controls.nVatAmount.enable();
        _thisCN.paytoCNForm.controls["nVatAmount"].clearValidators();
      }
    }
  }
  handler(select1): void {
    if (select1 == 1) {
      let Duedate = this.paytoCNForm.value.dDueDate; //get value dDue formControlName
      this.paytoCNForm.patchValue({ dDueDate: Duedate });
      let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, Duedate, this.holidays);
      this.message = (check_date < this.urgentDay && this.isSubmit != true && check_date > 0) ? 'You have ' + check_date + ' working days before due date. This is "Urgent" payment' : "";
      this.nReqUrgentDay = check_date;
      this.IsReqUrgent = check_date < this.urgentDay ? true : false;
    }
    if (select1 == 2) {
      let Invoicedate = this.paytoCNForm.value.dInvoiceDate;
      this.paytoCNForm.patchValue({ dInvoiceDate: Invoicedate });
    }
  }

  //#region "GetAutocomplete"
  async GetAutocomplete() {

    //AutocompleteMT_Vendor
    await this.http.get(this.System.SiteName + "api/Autocomplete/VD/10/" + this.nComcode + "").subscribe((data: Response) => {
      this.DataVendor = data;
      this.ArrVendor = this.DataVendor.map(re => ({ Vendor: re.VENDOR_CODE + " - " + re.sVendorName, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.sAddress, sVendorName: re.sVendorName, TAX_NUMBER1: re.TAX_NUMBER1, TAX_NUMBER2: re.TAX_NUMBER2, TAX_NUMBER3: re.TAX_NUMBER3, sValue: re.sValue }))
      this.paytoCNForm.patchValue({});
    })

    await this.http.get(this.System.SiteName + "api/Autocomplete/TUserpermission/*/sCompCode/" + this.nComcode + "/nRole/5").subscribe((data: Response) => {
      this.DataEmployee = data;
      this.ArrEmployee = this.DataEmployee.map(data => data.sName + " " + data.sSurName)
    })

    //AutocompleteTRequest
    this.ArrRequest = [];
    await this.http.get(this.System.SiteName + "api/_Paytovendor/GetCopyCNType/" + this.nComcode + "").subscribe((data: Response) => {
      this.DataRequest = data;
      if (this.DataRequest != null) {
        this.ArrRequest = this.DataRequest.map(re => re.sRequestCode)
      }
    })

    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteCOSTCENTER
    await this.http.get(this.System.SiteName + "api/_System/GetCostCenter", httpOptions_CostCenter).subscribe((data: Response) => {
      this.DataCostCenter = data;
      this.ArrCostCenter = this.DataCostCenter;
    })

    const httpOptions_GL = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteGL
    await this.http.get(this.System.SiteName + "api/_System/GetGL", httpOptions_GL).toPromise().then((data: Response) => {
      this.DataGL = data;
      this.sArrGL = this.DataGL;
    })

    const httpOptions_IO = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };

    //AutocompleteIO
    await this.http.get(this.System.SiteName + "api/_System/GetIO2", httpOptions_IO).subscribe((data: Response) => {
      this.DataIO = data;
      if (this.DataIO != null) {
        this.ArrIO = this.DataIO;
        this.ArrMaster[0] = this.ArrIO;
      }
    })


    //AutocompleteBankAccount
    this.DataBankBranch2 = [];
    this.masterDataBankBranch2 = [];


    //AutocompleteApprover
    await this.http.get(this.System.SiteName + "api/_Paytovendor/GetApproverAll/" + this.nComcode + "").toPromise().then((data: Response) => {
      if (data) {
        this.DataApprover = data;
      } else {
        this.DataApprover = [];
      }
      //  = this.DataApprover.map(f => f.name1);
      this.ArrApprover[0] = [];
      this.ArrApprover[1] = [];

      //GetApprover
      this.http.get(this.System.SiteName + "api/_Paytovendor/GetApprover/" + this.nComcode + "/60").toPromise().then((data: Response) => {
        if (data) {
          this.GetApprover = data[0];
        } else {
          this.GetApprover = null;
        }
        if (this.GetApprover != null) {
          if (this.GetApprover.cActive == "Y") {
            this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
            this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);

            if (this.GetApprover.IsApprover_1 == false) {
              this.paytoCNForm.controls['cSkipApprove1'].setValue(true);
              this.paytoCNForm.controls['ddApprover1'].disable();
            } else {
              let nUserId = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name1ID)[0];
              let name1 = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name1ID)[0];
              this.paytoCNForm.patchValue({
                sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
                ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
              })
            }
            if (this.GetApprover.IsApprover_2 == false) {
              this.paytoCNForm.controls['ddApprover2'].enable();
            } else {

              let name1 = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name2ID)[0];
              let nUserId = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name2ID)[0];
              this.paytoCNForm.patchValue({
                ddApprover2: isNullOrUndefined(name1) == true ? "" : name1.name1,
                sApprove2: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
              })
            }
          } else if (this.GetApprover.cActive == "N") {
            this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
            this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
          }

        }
      })
    })

    //ProvCode
    await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
      if (res) {
        this._ArrProvince = res;
      }
    });

    //Country
    await this.http.get<any>(this.System.SiteName + "api/_System/GetContry").toPromise().then(res => {
      if (res) {
        this._ArrCountry = res;
      }
    });

    //DropdownGetWHT
    await this.http.get(this.System.SiteName + "api/_Paytovendor/GetWHT").subscribe((data: Response) => {
      this.WHT = data;
    })
    //AutocompleteBankBranch
    this.DataBankBranch = [];


    //DropdownCurrency
    await this.http.get(this.System.SiteName + "api/Autocomplete/MT_CURRENCY/*").subscribe((data: Response) => {
      this.Currency = data;
    })

    //DropdownBank
    await this.http.get(this.System.SiteName + "api/Autocomplete/MT_BANK/*/Company/" + this.nComcode + "/Transfer/Y").subscribe((data: Response) => {
      this.Bank = data;
      if (this.Bank.length == 1) {
        this.paytoCNForm.patchValue({
          ddBank: this.Bank[0].BankName
        })
      }
    })

    //DropdownVatType
    await this.http.get(this.System.SiteName + "api/Autocomplete/Like/MT_VATTYPE/*/sReqType/60").subscribe((data: Response) => {
      let tempData: any;
      tempData = data
      this.VatType = tempData;
    })

    //DropdownBusinessAreas
    await this.http.get<any>(this.System.SiteName + "api/Autocomplete/MT_BUSINESS_AREA/*").subscribe(data => {
      if (data != null) {
        this.DataBusinessArea = data;
        this.paytoCNForm.patchValue({
          sBusinessArea: this.DataBusinessArea.filter(f => f.CompCode == this.nComcode)[0].BUSINESS_AREA,
        })
      }
    })

  }
  //#endregion


  forPX = () => {
    var vendor1 = this.paytoCNForm.value.nVendorCode + "XX";
    vendor1 = vendor1.substring(0, 2);
    var isNotPX1 = vendor1 === "PX";
    return isNotPX1;
  }

  unique = (value, index, self) => {
    return self.indexOf(value) === index
  }

  async onVendorSelect(event) {
    let _thisCN = this;
    let taxID = "";
    if (this.paytoCNForm.value.ntype2 == "60" || this.paytoCNForm.get('ntype2').value === 60) {
      await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/" + event.item.VENDOR_CODE).toPromise().then(res => {
        if (res) {
          this.DataBankBranch = res;
        }
        else {
          this.DataBankBranch = [];
        }
      })
      if (event.item.sValue == "Y") {
        this.DataBankBranch.push({ Show: "N/A", BANK_KEY: "N/A", NAME_OF_BANK: "N/A" })
      }
      if (this.DataBankBranch.length > 0) {
        this.paytoCNForm.patchValue({
          ddBankKey: this.DataBankBranch[0].NAME_OF_BANK,
          nBankKey: this.DataBankBranch[0].BANK_KEY,
        })
        if (event.item.sValue == "Y" && this.DataBankBranch[0].BANK_KEY === "N/A") {
          this.DataBankBranch2 = [{ Show: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
        }
        else {
          await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/VENDOR_CODE/" + event.item.VENDOR_CODE + "/BANK/" + this.DataBankBranch[0].BANK_KEY + "/PARTNER_BANK/ASC").toPromise().then((data: any) => {
            this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
          })
        }
        if (this.DataBankBranch2.length > 0) {
          this.paytoCNForm.patchValue({
            ddBankKey2: this.DataBankBranch2[0].BANK_ACCOUNT,
            nBankKey2: this.DataBankBranch2[0].BANK_ACCOUNT,
          })
        }
        if (this.paytoCNForm.get('ntype2').value === "60" || this.paytoCNForm.get('ntype2').value === 60) {
          this.paytoCNForm.controls['ddBankKey'].enable();
        }
        this.paytoCNForm.controls['ddBankKey2'].enable();
      }
      else {
        this.paytoCNForm.patchValue({
          ddBankKey: null,
          nBankKey: null,
          ddBankKey2: null,
          nBankKey2: null,
        })
        if (this.paytoCNForm.get('ntype2').value === "60" || this.paytoCNForm.get('ntype2').value === 60) {
          this.paytoCNForm.controls['ddBankKey'].enable();
        }
        this.paytoCNForm.controls['ddBankKey2'].disable();
      }
    }
    else {
      this.paytoCNForm.controls['ddBankKey'].setErrors({ 'invalid': true });
      if (this.paytoCNForm.get('ntype2').value === "60" || this.paytoCNForm.get('ntype2').value === 60) {
        this.paytoCNForm.controls['ddBankKey'].enable();
      }
      this.paytoCNForm.controls['ddBankKey2'].disable();
    }

    if (event.item.VENDOR_CODE != undefined && event.item.VENDOR_CODE != "") {
      let lstData = this.DataVendor.filter(s => s.VENDOR_CODE == event.item.VENDOR_CODE)[0]
      if (lstData != null) {
        if (lstData.TAX_NUMBER3 != null) {
          taxID = lstData.TAX_NUMBER3
        } else if (lstData.TAX_NUMBER3 == null && lstData.TAX_NUMBER2 != null) {
          taxID = lstData.TAX_NUMBER2;
        } else {
          taxID = lstData.TAX_NUMBER1;
        }
        this._ArrTumbon = [];
        const httpOptions_Amphur = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sProvCode", lstData.sProvCode)
        };
        await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
          if (res) {
            this._ArrAmphur = res;
          }
        });
        const httpOptions_Tumbon = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sAmpCode", lstData.sAmpCode)
        };
        await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
          if (res) {
            this._ArrTumbon = res;
          }
        });

        let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let Country = this._ArrCountry.filter(f => f.sCountryID == lstData.sCountryID)[0];
        let prov = this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];
        let value = { sCountryID: lstData.sCountryID == null ? "213" : lstData.sCountryID };
        let event = { item: value };
        await this.OnCountryselect(event);

        let tax = ""
        if (_thisCN.IsVendorOneTime == true) {
          tax = taxID == null ? "" : taxID
        }
        if (_thisCN.IsVendorOneTime == false) {
          tax = taxID == null ? "-" : taxID
        }
        this.paytoCNForm.patchValue({
          sCountryID: isNullOrUndefined(lstData.sCountryID) == true || _thisCN.IsVendorOneTime == true ? "213" : Country.sCountryID,
          sVendorEmail: _thisCN.IsVendorOneTime == true ? "" : lstData.sEMAIL,
          sFaxNumber: _thisCN.IsVendorOneTime == true ? "" : lstData.sFaxNumber,
          nVendorCode: lstData.VENDOR_CODE,
          txtCountryID: isNullOrUndefined(Country) == true || _thisCN.IsVendorOneTime == true ? "ประเทศไทย (Thailand)" : Country.sCountryName,
          sTAXID: tax,
          cbOffice: isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType,
          sVendorName: _thisCN.IsVendorOneTime == true ? "" : lstData.sVendorName,
          sAddress: _thisCN.IsVendorOneTime == true || lstData.sAddress == null ? "" : lstData.sAddress,
          sBranch: lstData.sBranch,
          sPhoneNumber: _thisCN.IsVendorOneTime == true ? "" : lstData.TEL,
          sAmpCode: lstData.sAmpCode == null || _thisCN.IsVendorOneTime == true ? "" : lstData.sAmpCode,
          sAmpName: isNullOrUndefined(Amp) == true || _thisCN.IsVendorOneTime == true ? "" : Amp.sAmpName,
          sPostCode: _thisCN.IsVendorOneTime == true ? "" : lstData.sPostCode,
          sBankAccountName: _thisCN.IsVendorOneTime == true ? "" : lstData.sVendorName, //lstData.sVendorName,
          sTumbonCode: _thisCN.IsVendorOneTime == true || lstData.sTumbonCode == null ? "" : lstData.sTumbonCode,
          sComcode: lstData.sComcode,
          sProvName: _thisCN.IsVendorOneTime == true || isNullOrUndefined(prov) == true ? "" : prov.sProvname,
          sProvCode: _thisCN.IsVendorOneTime == true ? "" : lstData.sProvCode == null ? "" : lstData.sProvCode,
          sTumbonName: _thisCN.IsVendorOneTime == true || isNullOrUndefined(tumbon) == true ? "" : tumbon.sTumbonName
        });
        if (lstData.nOfficeType == 1 || isNullOrUndefined(lstData.nOfficeType) == true) {
          this.paytoCNForm.controls['sBranch'].disable();
        }
        if (lstData.sCountryID != "213") {
          let sfield = ["sProvCode", "sAmpCode", "sTumbonCode", "sPostCode", "sPhoneNumber", "sFaxNumber", "sProvName", "sAmpName", "sTumbonName"]
        } else {
          this.isThai = true;
          let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]
          sfield.forEach(function (value) {
            _thisCN.paytoCNForm.controls[value].updateValueAndValidity();
            _thisCN.paytoCNForm.controls[value].enable();
            _thisCN.paytoCNForm.controls[value].setValidators([Validators.required]);
          })
          _thisCN.paytoCNForm.controls["sVendorEmail"].setValidators(Validators.email);
          _thisCN.paytoCNForm.controls["sVendorEmail"].updateValueAndValidity();
          _thisCN.paytoCNForm.controls["sVendorEmail"].enable();
        } if (lstData.sCountryID == null && this.IsVendorOneTime == true) {
          let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]
          sfield.forEach(function (value) {
            _thisCN.paytoCNForm.controls[value].enable();
            _thisCN.paytoCNForm.controls[value].updateValueAndValidity();
            _thisCN.paytoCNForm.controls[value].setValidators([Validators.required]);
          })
          _thisCN.paytoCNForm.controls["sVendorEmail"].setValidators(Validators.email);
          _thisCN.paytoCNForm.controls["sVendorEmail"].updateValueAndValidity();
          _thisCN.paytoCNForm.controls["sVendorEmail"].enable();
          this.isThai = true;
          this.paytoCNForm.patchValue({
            sCountryID: "213",
            sProvCode: "",
            sAmpCode: "",
            sPhoneNumber: "",
            txtCountryID: "ประเทศไทย (Thailand)",
            sVendorEmail: "",
            sTumbonCode: "",
            sPostCode: "",
            sFaxNumber: "",
            sAddressOneTime: "",
          })
          //ProvCode
          await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
            if (res) {
              this._ArrProvince = res;
            }
          });
        }
      } else {
        this.paytoCNForm.patchValue({
          sTAXID: null,
          sBranch: null,
          sVendorName: null,
          sAddress: null,
          cbOffice: 1,
          nVendorCode: null,
        })
      }
    } if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      let lstData = _thisCN.DataVendor.filter(s => s.VENDOR_CODE == event.item.VENDOR_CODE)[0];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", lstData.sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", lstData.sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        let taxID = "";
        if (lstData != "") {
          if (lstData.TAX_NUMBER3 != null) {
            taxID = lstData.TAX_NUMBER3
          } else if (lstData.TAX_NUMBER3 == null && lstData.TAX_NUMBER2 != null) {
            taxID = lstData.TAX_NUMBER2;
          } else {
            taxID = lstData.TAX_NUMBER1;
          }
        }
        let str;
        if (event.item.VENDOR_CODE != null) {
          let stype = event.item.VENDOR_CODE.substring(0, 2);
          if (stype == "PX") {
            str = 61;
          } else if (stype == "PF") {
            str = 60;
          } else {
            str = 61
          }
        }
        if (str == 60) {
          if (_IsNullOrEmpty(lstData.sVendorName) || _IsNullOrEmpty(lstData.sAddress)) {
            _thisCN.SW.SwAlert.Error(_thisCN.SW.BoxMsg.Title_Error, _thisCN.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
            return false;
          }
        }
        let Amp = _thisCN._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let prov = _thisCN._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = _thisCN._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];
        let tax = ""
        if (_thisCN.IsVendorOneTime == true) {
          tax = taxID == null ? "" : taxID
        }
        if (_thisCN.IsVendorOneTime == false) {
          tax = taxID == null ? "-" : taxID
        }
        invoice.sVendorBranch = lstData.sBranch;
        invoice.sVendorName = _thisCN.IsVendorOneTime == true ? "" : lstData.sVendorName;
        invoice.sVendorCode = lstData.VENDOR_CODE;
        invoice.sTAXID = tax;
        invoice.sProvCode = _thisCN.IsVendorOneTime == true || lstData.sProvCode == null ? "" : prov.sProvCode;
        invoice.sVendorAddress = _thisCN.IsVendorOneTime == true || lstData.sAddress == null ? "" : lstData.sAddress;
        invoice.cbOffice = isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType;
        invoice.sCountryID = _thisCN.IsVendorOneTime == true || lstData.sCountryID == null ? "213" : lstData.sCountryID;
        invoice.sAmpCode = _thisCN.IsVendorOneTime == true || lstData.sAmpCode == null ? "" : Amp.sAmpCode;
        invoice.sTumbonCode = _thisCN.IsVendorOneTime == true || lstData.sTumbonCode == null ? "" : tumbon.sTumbonCode;
        invoice.sAmpName = _thisCN.IsVendorOneTime == true || Amp == null ? lstData.sAmpName : Amp.sAmpName;
        invoice.sTumbonName = _thisCN.IsVendorOneTime == true || tumbon == null ? lstData.sTumbonName : tumbon.sTumbonName;
        invoice.sProvName = _thisCN.IsVendorOneTime == true || prov == null ? lstData.sProvName : prov.sProvname;
        invoice.sFaxNumber = _thisCN.IsVendorOneTime == true || lstData.sFaxNumber == null ? "" : lstData.sFaxNumber;
        invoice.sPostCode = _thisCN.IsVendorOneTime == true || lstData.sPostCode == null ? "" : lstData.sPostCode;
        invoice.sPhoneNumber = _thisCN.IsVendorOneTime == true || lstData.TEL == null ? "" : lstData.TEL;
        invoice.sVendorEmail = _thisCN.IsVendorOneTime == true || lstData.sEMAIL == null ? "" : lstData.sEMAIL;

      })

    }

  }
  //#region "Onetime"
  checkrange() {
    let _thisCN1 = this;
    var st1 = this.paytoCNForm.get('nVendorCode').value.length;
    if (st1 > 10 && this.paytoCNForm.get('ntype').value == 61) {
      let clear = function () {
        _thisCN1.paytoCNForm.get('nVendorCode').setValue("");
      }
      this.SW.SwAlert.Error(_thisCN1.SW.BoxMsg.Title_Error, _thisCN1.SW.BoxMsg.DescOneVendorLength, clear)
    }

  }
  async OnCountryselect(event) {
    let _thisCN = this;
    if (event.item.sCountryID != "213") {
      this._ArrProvince = [];
      this.isThai = true;
      this.paytoCNForm.patchValue({
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sCountryID: event.item.sCountryID,
        sVendorEmail: "",
        sTumbonName: "",
        sAmpName: "",
        sPhoneNumber: "",
        sTumbonCode: "",
        sFaxNumber: "",
        sAddressOneTime: "",
        sPostCode: "",
      })
    } else {
      //ProvCode
      await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
        if (res) {
          this._ArrProvince = res;
        }
      });

      this.isThai = true;
      this.paytoCNForm.patchValue({
        sCountryID: event.item.sCountryID,
        sProvName: "",
        sAmpName: "",
        sPhoneNumber: "",
        sTumbonCode: "",
        sTumbonName: "",
        sAmpCode: "",
        sPostCode: "",
        sProvCode: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      })
    }
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sCountryID = event.item.sCountryID == null ? null : event.item.sCountryID;
      })
    }
  }
  OnChangeAmphor(event) {
    let txtsProvName1 = this.paytoCNForm.get('sProvName').value
    //Amphur
    this._ArrTumbon = [];
    const httpOptions_Amphur = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sProvCode", event.item.sProvCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
      if (res) {
        this._ArrAmphur = res;
      } else {
        this._ArrAmphur = [];
      }
    });
    if ((this.paytoCNForm.get('sCountryID').value != "213" || this.sAmphorNoResult == false) && !_IsNullOrEmpty(txtsProvName1)) {
      this.paytoCNForm.patchValue({
        sProvName: event.value,
        sProvCode: isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode,
      });
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sProvName = event.value;
          invoice.sProvCode = isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode;
        })
      }
    } else if (this.sAmphorNoResult == true && this.paytoCNForm.get('sCountryID').value == "213") {
      this.paytoCNForm.patchValue({
        sProvName: null,
        sProvCode: isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode,
      });
    } else if (this.sAmphorNoResult == false && _IsNullOrEmpty(txtsProvName1) && this.paytoCNForm.get('sCountryID').value == "213") {
      this.paytoCNForm.patchValue({
        sProvName: null,
        sProvCode: null,
      });
    }
    //------------------------------------------------------- อำเภอเปลี่ยน อย่างอื่นก็ต้องเคลีย----------------------
    this.paytoCNForm.patchValue({
      sTumbonName: null,
      sTumbonCode: null,
      sAmpName: null,
      sAmpCode: null,
    });
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTumbonName = null
        invoice.sTumbonCode = null
        invoice.sAmpName = null
        invoice.sAmpCode = null
      })
    }
  }
  //Amphur
  OnChangeTumbon(event) {
    let txtsAmpName1 = this.paytoCNForm.get('sAmpName').value
    //Tumbon
    const httpOptions_Tumbon = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sAmpCode", event.item.sAmpCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
      if (res) {
        this._ArrTumbon = res;
      } else {
        this._ArrTumbon = [];
      }
    });
    if ((this.paytoCNForm.get('sCountryID').value != "213" || this.sTumbonNoResult == false) && !_IsNullOrEmpty(txtsAmpName1)) {
      this.paytoCNForm.patchValue({
        sAmpName: event.value,
        sAmpCode: isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode,
      });
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sAmpName = event.value;
          invoice.sAmpCode = isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode;
        })
      }
    } else if (this.sTumbonNoResult == true && this.paytoCNForm.get('sCountryID').value == "213") {
      this.paytoCNForm.patchValue({
        sAmpName: null,
        sAmpCode: isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode,
      });
    } else if (this.sTumbonNoResult == false && _IsNullOrEmpty(txtsAmpName1) && this.paytoCNForm.get('sCountryID').value == "213") {
      this.paytoCNForm.patchValue({
        sAmpName: null,
        sAmpCode: null,
      });
    }
    //------------------------------------------------------- อำเภอเปลี่ยน อย่างอื่นก็ต้องเคลีย------
    this.paytoCNForm.patchValue({
      sTumbonName: null,
      sTumbonCode: null,

    });
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTumbonName = null
        invoice.sTumbonCode = null
      })
    }
  }
  OnChangeSubDistrict(event) {
    let txtsTumbonName1 = this.paytoCNForm.get('sTumbonName').value
    if ((this.paytoCNForm.get('sCountryID').value != "213" || this.sSubDistrictNoResult == false) && !_IsNullOrEmpty(txtsTumbonName1)) {
      this.paytoCNForm.patchValue({
        sTumbonName: event.value,
        sTumbonCode: isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode,
      });
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sTumbonName = event.value;
          invoice.sTumbonCode = isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode;
        })
      }
    } else if (this.sSubDistrictNoResult == true && this.paytoCNForm.get('sCountryID').value == "213") {
      this.paytoCNForm.patchValue({
        sTumbonName: null,
        sTumbonCode: isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode,
      });
    } else if (this.sSubDistrictNoResult == false && _IsNullOrEmpty(txtsTumbonName1) && this.paytoCNForm.get('sCountryID').value == "213") {
      this.paytoCNForm.patchValue({
        sTumbonName: null,
        sTumbonCode: null,
      });
    }
  }
  async VendorNameChange(event) {
    let _thisCN = this;
    let lstData = event.item;
    let check = this.ArrVendorName.filter(f => f.sVendorName == lstData.sVendorName)[0];
    let sVendorName = this.paytoCNForm.get('sVendorName').value;
    if (check != null && !_IsNullOrEmpty(sVendorName)) {
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", lstData.sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", lstData.sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
      let Country = this._ArrCountry.filter(f => f.sCountryID == lstData.sCountryID)[0];
      let prov = this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
      let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];
      let value = { sCountryID: lstData.sCountryID == null ? "213" : lstData.sCountryID };
      let event = { item: value };
      await this.OnCountryselect(event).then();
      this.paytoCNForm.patchValue({
        sTAXID: _IsNullOrEmpty(lstData.sTAXID) ? "" : lstData.sTAXID,
        sAddress: lstData.sAddress == null ? "" : lstData.sAddress,
        sBankAccountName: _thisCN.paytoCNForm.get('cbChequeType').value == "C" ? "" : lstData.sVendorName,
        sPhoneNumber: lstData.sPhoneNumber,
        cbOffice: isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType,
        sAmpCode: lstData.sAmpCode == null ? "" : lstData.sAmpCode,
        sAmpName: isNullOrUndefined(Amp) == true ? "" : Amp.sAmpName,
        sBranch: lstData.sBranch,
        sComcode: lstData.sCompCode,
        sCountryID: lstData.sCountryID == null ? "213" : lstData.sCountryID,
        txtCountryID: isNullOrUndefined(Country) == true ? "ประเทศไทย (Thailand)" : Country.sCountryName,
        sVendorEmail: lstData.sEmail,
        sFaxNumber: lstData.sFaxNumber,
        sPostCode: lstData.sPostCode,
        sProvCode: lstData.sProvCode == null ? "" : lstData.sProvCode,
        sProvName: isNullOrUndefined(prov) == true ? "" : prov.sProvname,
        sTumbonCode: lstData.sTumbonCode == null ? "" : lstData.sTumbonCode,
        sTumbonName: isNullOrUndefined(tumbon) == true ? "" : tumbon.sTumbonName
      });
      if (lstData.nOfficeType == 1 || isNullOrUndefined(lstData.nOfficeType) == true) {
        this.paytoCNForm.controls['sBranch'].disable();
      }
      if (lstData.sCountryID != "213") {

      } else {
        this.isThai = true;
        let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]
        sfield.forEach(function (value) {
          _thisCN.paytoCNForm.controls[value].enable();
          _thisCN.paytoCNForm.controls[value].setValidators([Validators.required]);
          _thisCN.paytoCNForm.controls[value].updateValueAndValidity();
        })
        _thisCN.paytoCNForm.controls["sVendorEmail"].enable();
        _thisCN.paytoCNForm.controls["sVendorEmail"].setValidators(Validators.email);
        _thisCN.paytoCNForm.controls["sVendorEmail"].updateValueAndValidity();
      } if (lstData.sCountryID == null && this.IsVendorOneTime == true) {
        let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]

        sfield.forEach(function (value) {
          _thisCN.paytoCNForm.controls[value].enable();
          _thisCN.paytoCNForm.controls[value].setValidators([Validators.required]);
          _thisCN.paytoCNForm.controls[value].updateValueAndValidity();
        })

        let sfields = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]
        sfields.forEach(function (value) {
          _thisCN.paytoCNForm.controls[value].enable();
          _thisCN.paytoCNForm.controls[value].updateValueAndValidity();
        })
        _thisCN.paytoCNForm.controls["sVendorEmail"].enable();
        _thisCN.paytoCNForm.controls["sVendorEmail"].setValidators(Validators.email);
        _thisCN.paytoCNForm.controls["sVendorEmail"].updateValueAndValidity();
        this.isThai = true;
        this.paytoCNForm.patchValue({
          txtCountryID: "ประเทศไทย (Thailand)",
          sCountryID: "213",
          sProvCode: "",
          sAmpCode: "",
          sTumbonCode: "",
          sPostCode: "",
          sPhoneNumber: "",
          sFaxNumber: "",
          sVendorEmail: "",
          sAddressOneTime: "",
        })
        //ProvCode
        await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
          if (res) {
            this._ArrProvince = res;
          }
        });
      }
    } else {
      lstData = {};
      this.paytoCNForm.patchValue({
        sTAXID: null,
        cbOffice: 1,
        sBranch: null,
        sAddress: null,
        sCountryID: "213",
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      })
    } if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        if (_IsNullOrEmpty(lstData.sVendorName) || _IsNullOrEmpty(lstData.sAddress) || _IsNullOrEmpty(lstData.sTAXID)) {
          _thisCN.SW.SwAlert.Error(_thisCN.SW.BoxMsg.Title_Error, _thisCN.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
          // return false;
        }
        let Amp = _thisCN._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let prov = _thisCN._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = _thisCN._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];

        invoice.sTAXID = _IsNullOrEmpty(lstData.sTAXID) ? "" : lstData.sTAXID;
        invoice.sVendorName = isNullOrUndefined(lstData.sVendorName) ? event.value : lstData.sVendorName;
        invoice.cbOffice = isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType;
        invoice.sVendorBranch = isNullOrUndefined(lstData.sBranch) == true ? "" : lstData.sBranch;
        invoice.sVendorAddress = isNullOrUndefined(lstData.sAddress) == true ? "" : lstData.sAddress;
        invoice.sCountryID = isNullOrUndefined(lstData.sCountryID) == true ? "213" : lstData.sCountryID;
        invoice.sProvCode = isNullOrUndefined(lstData.sProvCode) == true ? "" : prov.sProvCode;
        invoice.sProvName = prov == null ? lstData.sProvName : prov.sProvname;
        invoice.sAmpCode = isNullOrUndefined(lstData.sAmpCode) == true ? "" : Amp.sAmpCode;
        invoice.sAmpName = Amp == null ? lstData.sAmpName : Amp.sAmpName;
        invoice.sTumbonCode = isNullOrUndefined(lstData.sTumbonCode) == true ? "" : tumbon.sTumbonCode;
        invoice.sTumbonName = tumbon == null ? lstData.sTumbonName : tumbon.sTumbonName;
        invoice.sPostCode = isNullOrUndefined(lstData.sPostCode) == true ? "" : lstData.sPostCode;
        invoice.sPhoneNumber = isNullOrUndefined(lstData.sPhoneNumber) == true ? "" : lstData.sPhoneNumber;
        invoice.sFaxNumber = isNullOrUndefined(lstData.sFaxNumber) == true ? "" : lstData.sFaxNumber;
        invoice.sVendorEmail = isNullOrUndefined(lstData.sEMAIL) == true ? "" : lstData.sEmail;
        // invoice.sAddressOneTime = data.sAddressOneTime;

      })
    }
    if (this.IsVendorOneTime == true) {
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (event.value != null && !_IsNullOrEmpty(sVendorName)) {
            invoice.sVendorName = event.value == null ? "" : event.value;
          } else {
            invoice.sVendorName = "";
          }
        })
      }
    }
    if (this.IsVendorOneTime == false) {
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (event.target.value != null && !_IsNullOrEmpty(sVendorName)) {
            invoice.sVendorName = event.target.value == null ? "" : event.target.value;
          } else {
            invoice.sVendorName = "";
          }
        })
      }
    }
  }
  AddressChange(event) {
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorAddress = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  TAXIDChange(event) {
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTAXID = event.target.value == null ? "" : event.target.value;
      })
    }
  }

  BranchChange(event) {
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorBranch = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  CommentChange(event) {
    this.paytoCNForm.patchValue({
      sComment: event.target.value,
    });
    this.sComment = event.target.value == null ? "" : event.target.value;
  }
  CommentChangeSSC(event) {
    this.paytoCNForm.patchValue({
      sCommentSSC: event.target.value,
    });
    this.sCommentSSC = event.target.value == null ? "" : event.target.value;
  }

  PhoneNumberChange(event) {
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sPhoneNumber = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  PostCodeChange(event) {
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sPostCode = event.target.value == null ? "" : event.target.value;
      })
    }
  }




  EmailChange(event) {
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorEmail = event.target.value == null ? "" : event.target.value;
      })
    }

  }
  FaxNumberChange(event) {
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
      this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sFaxNumber = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  //#region "Onetime"

  formatnumber(Digit: number, Grouping: boolean, Data: number): string {
    var currencyChars = new RegExp('[\,]', 'g');

    if (isNaN(Data)) {
      return null;
    } else {
      var item = parseFloat(String(Data).replace(currencyChars, ''));
      return new Intl.NumberFormat('en', { maximumFractionDigits: Digit, minimumFractionDigits: Digit, useGrouping: Grouping }).format(item);
    }
  }
  //#endregoin
  keyPress(event: any, byTotal) {
    let Total: number = _ParseFloatToZero(this.paytoCNForm.value.nTotalAmountVat)
    if (Total > 0) Total = Total * -1;
    let Vat: number = this.paytoCNForm.value.nVat == null ? 0 : this.paytoCNForm.value.nVat;
    let WHTRate: number = this.paytoCNForm.value.nWHTRate
    let WHTRate2: number = this.paytoCNForm.value.nWHTRate2
    let VatAmount: number = Total * Vat;
    let include = this.formatnumber(2, true, VatAmount + Total);
    let nTotalAmountInvoice = this._ConvertToDecimal(include);
    this.paytoCNForm.patchValue({
      nTotalAmountInvoice: nTotalAmountInvoice,
      nVatAmount: this._ConvertToDecimal(VatAmount.toFixed(2)),
    })

    let WHTBase: number = 0;
    let WHTBase2: number = 0;
    
    if (WHTRate !== null && WHTRate !== 0) {
      if (byTotal) {
        WHTBase = Number(Total);
      }
      else {
        let nWHTBase: number = _ParseFloatToZero(this.paytoCNForm.controls['nWHTBase'].value).toFixed(2);
        if (nWHTBase > 0) nWHTBase = nWHTBase * -1;
        WHTBase = Number(nWHTBase);
      }
    }
    
    let nWHTBase2: number = _ParseFloatToZero(this.paytoCNForm.controls['nWHTBase2'].value).toFixed(2);
    if (nWHTBase2 > 0) nWHTBase2 = nWHTBase2 * -1;
    WHTBase2 = Number(nWHTBase2);

    let WHTAmount: number = WHTBase * WHTRate / 100;
    let WHTAmount2: number = WHTBase2 * WHTRate2 / 100;

    this.paytoCNForm.patchValue({
      nWHTVal: this._ConvertToDecimal(WHTAmount.toFixed(2)),
      _nWHTVal: this._ConvertToDecimal(WHTAmount.toFixed(2)),
      nWHTVal2: this._ConvertToDecimal(WHTAmount2.toFixed(2)),
      _nWHTVal2: this._ConvertToDecimal(WHTAmount2.toFixed(2)),
      nWHTBase: this._ConvertToDecimal(WHTBase.toFixed(2)),
      nWHTBase2: this._ConvertToDecimal(WHTBase2.toFixed(2)),
    })
  }
  keyVat(event: any) {
    let Total: number = _ParseFloatToZero(this.paytoCNForm.value.nTotalAmountVat)
    let include = this.formatnumber(2, true, Total + Number(event.target.value));
    this.paytoCNForm.patchValue({
      nTotalAmountInvoice: this._ConvertToDecimal(include),
    })

  }
  KeyWithholdingRate(event: any, mode: number) {
    let WHYRate: number = event.target.value;
    
    if (mode === 1) {
    let Total: number = _ParseFloatToZero(this.paytoCNForm.value.nWHTBase).toFixed(2)
    if (Total > 0) Total = Total * -1
    let nWHTVal = this._ConvertToDecimal((Number(Total * (WHYRate / 100))).toFixed(2));
    
      this.paytoCNForm.patchValue({
        WHYRate: WHYRate,
        nWHTVal: nWHTVal,
        _nWHTVal: nWHTVal,
      });
      if (WHYRate){
        this.paytoCNForm.patchValue({
          nWHTRate: WHYRate,
        });
      }
    }
    else{
    let Total: number = _ParseFloatToZero(this.paytoCNForm.value.nWHTBase2).toFixed(2)
    if (Total > 0) Total = Total * -1
    let nWHTVal2 = this._ConvertToDecimal((Number(Total * (WHYRate / 100))).toFixed(2));
    
      this.paytoCNForm.patchValue({
        WHYRate2: WHYRate,
        nWHTVal2: nWHTVal2,
        _nWHTVal2: nWHTVal2,
      });
      if (WHYRate){
        this.paytoCNForm.patchValue({
          nWHTRate2: WHYRate,
        });
      }
    }
   
  }

  KeyWithholdingAmount(mode: number){
    const _this = this;
    let ddlWithholdingTax = _this.paytoCNForm.value.ddlWithholdingTax;
    if (ddlWithholdingTax !== '0' && ddlWithholdingTax !== 0) {
      let nWHTVal: number = 0;
      let _nWHTVal: number = 0;
      let nWHTValNew: any;
      let _nWHTValNew: any;
      if (mode === 1) {
          nWHTVal = Number(_ParseFloatToZero(_this.paytoCNForm.value.nWHTVal).toFixed(2));
          _nWHTVal = Number(_ParseFloatToZero(_this.paytoCNForm.value._nWHTVal).toFixed(2));
          nWHTValNew = _this.paytoCNForm.value.nWHTVal;
          _nWHTValNew = _this.paytoCNForm.value._nWHTVal;
      }
      else {
          nWHTVal = Number(_ParseFloatToZero(_this.paytoCNForm.value.nWHTVal2).toFixed(2));
          _nWHTVal = Number(_ParseFloatToZero(_this.paytoCNForm.value._nWHTVal2).toFixed(2));
          nWHTValNew = this.paytoCNForm.value.nWHTVal2;
          _nWHTValNew = this.paytoCNForm.value._nWHTVal2;
      }
      if (Math.abs(nWHTVal - _nWHTVal) > 1){
        nWHTValNew = _nWHTValNew;
        _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Error_Amount, null)
      }
      if (mode === 1) {
        _this.paytoCNForm.patchValue({
          nWHTVal: nWHTValNew,
          _nWHTVal: _nWHTValNew,
        });
      }
      else {
        _this.paytoCNForm.patchValue({
          nWHTVal2: nWHTValNew,
          _nWHTVal2: _nWHTValNew,
        })
      }
    }
  }

  KeyWithholding(event: any, mode: number) {
    // let nWHTVal = this._ConvertToDecimal((Number(event.target.value)).toFixed(2));
    if (event.target.value === '') {
      if (mode === 1) {
        this.paytoCNForm.patchValue({
          nWHTVal: '0.00',
          _nWHTVal: '0.00',
        });
      }
      else {
        this.paytoCNForm.patchValue({
          nWHTVal2: '0.00',
          _nWHTVal2: '0.00',
        })
      }
    }
  }
  KeyWithholdingBase(event: any, mode: number) {
    // let nWHTVal = this._ConvertToDecimal((Number(event.target.value)).toFixed(2));
    if (event.target.value === '') {
      if (mode === 1) {
        this.paytoCNForm.patchValue({
          nWHTBase: '0.00',
        });
      }
      else {
        this.paytoCNForm.patchValue({
          nWHTBase2: '0.00',
        })
      }
    }
  }
  onWithholdingTaxSelect(mode: number, isEdit: boolean) {
    if (mode === 1) {
      let ddlWithholdingTax = this.paytoCNForm.value.ddlWithholdingTax;
      let nWHTBase = _ParseFloatToZero(this.paytoCNForm.value.nWHTBase).toFixed(2);
      let nWHTVal: number = 0;
      let nWHTOther: number = null;
      let nWHTRate = this.WHT.filter(f => f.nRate == ddlWithholdingTax && ddlWithholdingTax !== ' ')[0];
      let nWHT = this.WHT.filter(f => f.nRate == ddlWithholdingTax && ddlWithholdingTax !== ' ')[0];
      if (nWHTRate != null) {
        nWHTRate = nWHTRate.nRate;
      } else {
        nWHTRate = 0;
      }
      if (nWHTRate !== 0) {
        if(nWHTBase === '0.00' || nWHTBase === ''){
          let nTotalAmountVat = Number(this.paytoCNForm.value.nTotalAmountVat);
          if (nTotalAmountVat > 0) nTotalAmountVat = nTotalAmountVat * -1

          this.paytoCNForm.patchValue({
            nWHTBase: this._ConvertToDecimal((nTotalAmountVat).toFixed(2)),
          });
          nWHTBase = _ParseFloatToZero(this.paytoCNForm.value.nWHTBase).toFixed(2);
        }
      }

      let IsWithholdingTax = nWHTRate == 0 ? true : false;
      if (nWHTRate === 0) IsWithholdingTax = true;
      if (IsWithholdingTax == true && ddlWithholdingTax !== " ") {
        nWHTOther = nWHTRate;
        this.paytoCNForm.controls['nWHTOther'].enable();
        this.paytoCNForm.controls['nWHTOther'].setValidators([Validators.required]);
        this.paytoCNForm.controls['nWHTOther'].setErrors({ 'invalid': true });
        this.paytoCNForm.controls['nWHTOther'].updateValueAndValidity();
        // if (ddlWithholdingTax === '0' || ddlWithholdingTax === 0) {
        //   this.paytoCNForm.controls['nWHTVal'].enable();
        //   this.paytoCNForm.controls['nWHTVal'].setValidators([Validators.required]);
        //   this.paytoCNForm.controls['nWHTVal'].setErrors({ 'invalid': true });
        //   this.paytoCNForm.controls['nWHTVal'].updateValueAndValidity();
        // }
        // else {
        //   this.paytoCNForm.controls['nWHTVal'].disable();
        //   this.paytoCNForm.controls['nWHTVal'].clearValidators();
        //   this.paytoCNForm.controls['nWHTVal'].setValidators(null);
        //   this.paytoCNForm.controls['nWHTVal'].setErrors({ 'invalid': false });
        //   this.paytoCNForm.controls['nWHTVal'].markAsUntouched({ onlySelf: true });
        //   this.paytoCNForm.controls['nWHTVal'].updateValueAndValidity();
        // }
      } else if (IsWithholdingTax == false || ddlWithholdingTax == " ") {
        this.paytoCNForm.controls['nWHTOther'].disable();
        this.paytoCNForm.controls['nWHTOther'].clearValidators();
        this.paytoCNForm.controls['nWHTOther'].setValidators(null);
        this.paytoCNForm.controls['nWHTOther'].setErrors({ 'invalid': false });
        this.paytoCNForm.controls['nWHTOther'].markAsUntouched({ onlySelf: true });
        this.paytoCNForm.controls['nWHTOther'].updateValueAndValidity();
        // this.paytoCNForm.controls['nWHTVal'].disable();
        // this.paytoCNForm.controls['nWHTVal'].clearValidators();
        // this.paytoCNForm.controls['nWHTVal'].setValidators(null);
        // this.paytoCNForm.controls['nWHTVal'].setErrors({ 'invalid': false });
        // this.paytoCNForm.controls['nWHTVal'].markAsUntouched({ onlySelf: true });
        // this.paytoCNForm.controls['nWHTVal'].updateValueAndValidity();
        nWHTVal = Number(nWHTBase * (nWHTRate / 100));
      }
      if (isEdit) {
        if (nWHTVal > 0) nWHTVal = nWHTVal * -1
        this.paytoCNForm.patchValue({
          nWHTID: nWHT == undefined ? null : nWHT.nWHTID,
          nWHTRate: nWHTRate,
          nWHTOther: nWHTOther,
          nWHTVal: this._ConvertToDecimal(nWHTVal.toFixed(2)),
          _nWHTVal: this._ConvertToDecimal(nWHTVal.toFixed(2)),
        });
      }
    }
    else{
      let ddlWithholdingTax2 = this.paytoCNForm.value.ddlWithholdingTax2;
      let nWHTBase2 = _ParseFloatToZero(this.paytoCNForm.value.nWHTBase2).toFixed(2);
      let nWHTVal2: number = 0;
      let nWHTOther2: number = null;
      let nWHTRate2 = this.WHT.filter(f => f.nRate == ddlWithholdingTax2 && ddlWithholdingTax2 !== ' ')[0];
      let nWHT2 = this.WHT.filter(f => f.nRate == ddlWithholdingTax2 && ddlWithholdingTax2 !== ' ')[0];
      if (nWHTRate2 != null) {
        nWHTRate2 = nWHTRate2.nRate;
      } else {
        nWHTRate2 = 0;
      }
      let IsWithholdingTax2 = nWHTRate2 == 0 ? true : false;
      if (nWHTRate2 === 0) IsWithholdingTax2 = true;
      if (IsWithholdingTax2 == true && ddlWithholdingTax2 !== " ") {
        nWHTOther2 = nWHTRate2;
        this.paytoCNForm.controls['nWHTOther2'].enable();
        this.paytoCNForm.controls['nWHTOther2'].setValidators([Validators.required]);
        this.paytoCNForm.controls['nWHTOther2'].setErrors({ 'invalid': true });
        this.paytoCNForm.controls['nWHTOther2'].updateValueAndValidity();
        if (ddlWithholdingTax2 === '0' || ddlWithholdingTax2 === 0) {
          this.paytoCNForm.controls['nWHTVal2'].enable();
          this.paytoCNForm.controls['nWHTVal2'].setValidators([Validators.required]);
          this.paytoCNForm.controls['nWHTVal2'].setErrors({ 'invalid': true });
          this.paytoCNForm.controls['nWHTVal2'].updateValueAndValidity();
        }
        else {
          this.paytoCNForm.controls['nWHTVal2'].disable();
          this.paytoCNForm.controls['nWHTVal2'].clearValidators();
          this.paytoCNForm.controls['nWHTVal2'].setValidators(null);
          this.paytoCNForm.controls['nWHTVal2'].setErrors({ 'invalid': false });
          this.paytoCNForm.controls['nWHTVal2'].markAsUntouched({ onlySelf: true });
          this.paytoCNForm.controls['nWHTVal2'].updateValueAndValidity();
        }
      } else if (IsWithholdingTax2 == false || ddlWithholdingTax2 == " ") {
        this.paytoCNForm.controls['nWHTOther2'].disable();
        this.paytoCNForm.controls['nWHTOther2'].clearValidators();
        this.paytoCNForm.controls['nWHTOther2'].setValidators(null);
        this.paytoCNForm.controls['nWHTOther2'].setErrors({ 'invalid': false });
        this.paytoCNForm.controls['nWHTOther2'].markAsUntouched({ onlySelf: true });
        this.paytoCNForm.controls['nWHTOther2'].updateValueAndValidity();
        this.paytoCNForm.controls['nWHTVal2'].disable();
        this.paytoCNForm.controls['nWHTVal2'].clearValidators();
        this.paytoCNForm.controls['nWHTVal2'].setValidators(null);
        this.paytoCNForm.controls['nWHTVal2'].setErrors({ 'invalid': false });
        this.paytoCNForm.controls['nWHTVal2'].markAsUntouched({ onlySelf: true });
        this.paytoCNForm.controls['nWHTVal2'].updateValueAndValidity();
        nWHTVal2 = Number(nWHTBase2 * (nWHTRate2 / 100));
      }
      if (isEdit) {
        if (nWHTVal2 > 0) nWHTVal2 = nWHTVal2 * -1
        this.paytoCNForm.patchValue({
          nWHTID2: nWHT2 == undefined ? null : nWHT2.nWHTID,
          nWHTRate2: nWHTRate2,
          nWHTOther2: nWHTOther2,
          nWHTVal2: this._ConvertToDecimal(nWHTVal2.toFixed(2)),
          _nWHTVal2: this._ConvertToDecimal(nWHTVal2.toFixed(2)),
        });
      }
    }
   
  }
  onGLSelect(row) {
    this.sGL = this.ArrGL.value.sGL
  }
  async onCostCenterSelect(sCost, row) {
    let _thisCN = this;
    if (sCost != undefined && sCost != "") {
      let lstData = this.DataCostCenter.filter(s => s.COST_CENTER == sCost)[0]
      let nCostCode = lstData.COST_CENTER;
      const httpOptions_IO = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sCompCode", this.nComcode)
      };

      //AutocompleteIO
      await this.http.get(_thisCN.System.SiteName + "api/_System/GetIO2", httpOptions_IO).toPromise().then((data: Response) => {
        this.DataIO = data;
        if (this.DataIO != null) {
          this.ArrMaster[row] = this.DataIO;
        } else {
          this.ArrMaster[row] = ["", ""];
        }
      })
    }
  }
  Onbankother(value) {
    if (value.target.value == "Other, please specify") {
      this.hidbankother = false;
      this.paytoCNForm.controls["BankOther"].updateValueAndValidity();
      this.paytoCNForm.controls["BankOther"].markAsTouched({ onlySelf: true });
      this.paytoCNForm.controls["BankOther"].enable()
      this.paytoCNForm.controls["BankOther"].setValidators([Validators.required]);
    } else {
      this.paytoCNForm.patchValue({ BankOther: null })
      this.hidbankother = true;
      this.paytoCNForm.controls["BankOther"].markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls["BankOther"].updateValueAndValidity();
      this.paytoCNForm.controls["BankOther"].setValidators([]);
      this.paytoCNForm.controls["BankOther"].clearValidators();
      this.paytoCNForm.controls["BankOther"].setErrors(null);
      this.paytoCNForm.controls["BankOther"].disable()
    }

  }
  async Save(mode) {
    //#region CheckValidate
    let _thisCN = this;
    let _FormGroup = this.paytoCNForm;
    let IsValid: boolean = true;
    if (ArrFile.filter(f => f.IsDelete === false).length <= 0 && mode !== 1) {
      IsValid = false;
      const chkFile =  document.getElementById('dv_dvFile');
      chkFile.style.border = '1px solid red';
    }
    let FieldValid: string[] = [];
    if (mode != 3) {
      if (mode == 1) {
        FieldValid = ["sName"];
      }
      if (mode == 2 && this.ArrRequestCN.filter(f => f.cActive != 'N').length == 0) {
        FieldValid = ["sName", "dDueDate", "sInvoiceNo", "sInvoiceRef", "sYearInvoiceRef", "sVendorName", "sTAXID", "sAddress"
          , "dInvoiceDate", "ddVatType", "nTotalAmountVat", , "nVatAmount", "ddApprover2", "ddApprover1", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
      }
      if (mode == 2 && this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        if (_IsNullOrEmpty(_thisCN.paytoCNForm.get('sVendorName').value) || _IsNullOrEmpty(_thisCN.paytoCNForm.get('sAddress').value) || _IsNullOrEmpty(_thisCN.paytoCNForm.get('sTAXID').value)) {
          _thisCN.SW.SwAlert.Error(_thisCN.SW.BoxMsg.Title_Error, _thisCN.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
          _thisCN.clicked = false;
          return false;
        }
        FieldValid = ["ddApprover2", "ddApprover1", "txtCountryID", "sProvName", "sAmpName", "sTumbonName", "sInvoiceRef", "sYearInvoiceRef"];
        FieldValid.forEach(function (Field) {
          if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled == false) {
            IsValid = false;
          }
        })
      }
      let arrbank = ["ddBank", "ddBankKey"];
      if (_FormGroup.get('ntype2').value == "60") {
        arrbank.push("ddBankKey2")
      }
      else {
        arrbank.push("nBankAccountNo")
      }
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length == 0) {
        FieldValid.forEach(function (Field) {
          if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled == false) {
            IsValid = false;
          }
        });
        //เช็ค ArrGL
        if (IsValid) {
          if (mode == 2 && this.ArrRequestCN.filter(f => f.cActive != 'N').length == 0) {
            IsValid = false;
          }
          let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT", "sText"];
          for (let i = 0; i < this.ArrGL.length; i++) {
            FieldGLValid.forEach(function (Field) {
              let FromArray = _FormGroup.get('ArrGL') as FormArray;
              if (!FromArray.at(i).get(Field).valid && mode != 1) {
                IsValid = false;
                _thisCN.clicked = false;
                return false;
              }
            });
          }
        }
      }
      arrbank.forEach(function (bank) {
        if ((!_FormGroup.get(bank).valid) && _thisCN.paytoCNForm.value.cbChequeType != 'C' && mode != 1) {
          const control = _FormGroup.get(bank);
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
            IsValid = false;
          }
        }
      })
      let arrinvoice = _thisCN.ArrRequestCN.filter(f => f.IsDelete == false && f.cActive != 'N')
      let arrsum = arrinvoice.map(m => _thisCN.Check2Digit(m.sAmount));
      let arrsumm = [];
      let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2);
      let GroupByinvoice = [];


      _thisCN.ArrRequestCN.filter(f => f.IsDelete == false && f.cActive != 'N').forEach(function (value, i) {
        let obj = {
          invoice: value.sInvoiceNo,
          InvoiceDate: value.dInvoiceDate
        }
        let ckhave = GroupByinvoice.filter(f => f.invoice == obj.invoice && f.InvoiceDate == obj.InvoiceDate);
        if (ckhave.length == 0) {
          GroupByinvoice.push(obj)
        }

      });
      GroupByinvoice.forEach(function (value, i) {
        let Get_nExcludeVAT = _thisCN.ArrRequestCN.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate && f.IsDelete == false && f.cActive != 'N');
        if (Get_nExcludeVAT.length > 0) {
          arrsumm.push(_thisCN.Check2Digit(Get_nExcludeVAT[0].nExcludeVAT));
        }
      })

      var isBreak = false;
      for (var i = 0; i < GroupByinvoice.length; i++) {
        let ck = _thisCN.ArrRequestCN.filter(f => f.sInvoiceNo == GroupByinvoice[i].invoice && f.dInvoiceDate == GroupByinvoice[i].InvoiceDate)[0];
        let result = await _thisCN.EditcheckDupinBase(ck.sInvoiceNo, ck.dInvoiceDate, _thisCN.paytoCNForm.get('sRequestID').value);
        if (result == "Dup") {
          isBreak = true;
          break;
        }
      }
      if (isBreak) {
        _thisCN.SW.SwAlert.Error(_thisCN.SW.BoxMsg.Title_Error, _thisCN.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
        _thisCN.clicked = false;
        return false;
      }

      let sumExclude = arrsumm.reduce((acc, cur) => (acc + cur), 0).toFixed(2);
      sumNumber = sumNumber.replace('-', '');
      sumExclude = sumExclude.replace('-', '');
      if (sumNumber ==  sumExclude) {
        //#endregion
        if (IsValid) {
          let arr = _thisCN.ArrRequestCN;
          for (var i = 0; i < arr.length; i++) {
            let WHTVal = arr[i].nWHTVal;
            let WHTVal2 = arr[i].nWHTVal2;
            let WHTBase = arr[i].nWHTBase;
            let WHTBase2 = arr[i].nWHTBase2;
            if (WHTVal) {
              if(typeof WHTVal === 'string'){
                arr[i].nWHTVal = _ParseFloatToZero(WHTVal);
              }
            }
            if (WHTVal2) {
              if(typeof WHTVal2 === 'string'){
                arr[i].nWHTVal2 = _ParseFloatToZero(WHTVal2);
              }
            }
            if (WHTBase) {
              if(typeof WHTBase === 'string'){
                arr[i].nWHTBase = _ParseFloatToZero(WHTBase);
              }
            }
            if (WHTBase2) {
              if(typeof WHTBase2 === 'string'){
                arr[i].nWHTBase2 = _ParseFloatToZero(WHTBase2);
              }
            }
            if(arr[i].nExcludeVAT) arr[i].nExcludeVAT = -Math.abs(arr[i].nExcludeVAT)
          }
          let DataSave = {
            TRequest: {
              IsReqUrgent: _thisCN.IsReqUrgent,
              IsSSCUrgent: false,
              IsVendorGroup: false,
              sVendorCode: _thisCN.paytoCNForm.get('nVendorCode').value,
              sCurrency: _thisCN.paytoCNForm.get('ddCurrency').value,
              nStatusID: (mode == 1) ? 1 : 2,
              sCopyReqID: _thisCN.paytoCNForm.get('nCopyRequest').value,
              nStep: 1,
              nFlowNo: 1,
              sRequestID: _thisCN.paytoCNForm.get('sRequestID').value,
              sCompCode: _thisCN.nComcode,
              nInvoiceType: "",
              sRefAdvanceNo: "",
              sContactName: _thisCN.paytoCNForm.get('sName').value,
              dDueDate: _thisCN.datepipe.transform(_thisCN.paytoCNForm.get('dDueDate').value, 'dd/MM/yyyy'),
              sUnitName: _thisCN.paytoCNForm.get('sUnit').value,
              sEmail: _thisCN.paytoCNForm.get('sEmail').value,
              sTel: _thisCN.paytoCNForm.get('sTel').value,
              sCreateBy: _thisCN.paytoCNForm.get('sRequestBy').value + "",
              sUpdateBy: _thisCN.paytoCNForm.get('sRequestBy').value + "",
              sDeleteBy: "",
              cSkipApprove1: _thisCN.paytoCNForm.get('cSkipApprove1').value == 1 ? "Y" : "N",
              nApprove1: _thisCN.paytoCNForm.get('sApprove1').value,
              cApprove1: "W",
              nApprove2: _thisCN.paytoCNForm.get('sApprove2').value,
              cApprove2: "W",
              sPaymentType: _thisCN.paytoCNForm.get('cbChequeType').value,
              sBankName: _thisCN.paytoCNForm.get('ddBank').value,
              sAccountName: _thisCN.paytoCNForm.get('sBankAccountName').value,
              sInvoiceRef: _thisCN.paytoCNForm.get('sInvoiceRef').value,
              sYearInvoiceRef: _thisCN.paytoCNForm.get('sYearInvoiceRef').value,
              sAccountNo: _thisCN.paytoCNForm.get('ntype2').value === "60" || _thisCN.paytoCNForm.get('ntype2').value === 60 ? _thisCN.paytoCNForm.get('ddBankKey2').value : _thisCN.paytoCNForm.get('nBankAccountNo').value,
              sBankKey: _thisCN.paytoCNForm.get('nBankKey').value,
              BankOther: _thisCN.paytoCNForm.get('BankOther').value,
              nGrandTotalAmt: _ParseFloatToZero(_thisCN.paytoCNForm.get('GtotalAmountExcluded').value),
              nGrandTotalAmtVat: _ParseFloatToZero(_thisCN.paytoCNForm.get('GtotalVAT').value),
              nGrandTotalWithholdingTax: _ParseFloatToZero(_thisCN.paytoCNForm.get('GtotalWithholdingTax').value),
              nGrandTotalAmtInvoice: _ParseFloatToZero(_thisCN.paytoCNForm.get('GtotalAmountOfInvoice').value),
              nReqType: _thisCN.paytoCNForm.get('ntype').value + "",
              nYear: _thisCN.datepipe.transform(_thisCN.today, 'yyyy'),
              sRequestBy: _thisCN.paytoCNForm.get('sRequestBy').value + "",
              dRequestDate: _thisCN.dToday,
              nContactID: Number(_thisCN.paytoCNForm.get('nContactID').value),
              cSkipApprove2: "N",
              sBusinessArea: _thisCN.paytoCNForm.get('sBusinessArea').value,
              nReqUrgentDay: _thisCN.nReqUrgentDay,
              dStartDate: _thisCN.Settodate,
              sComment: _thisCN.paytoCNForm.get('sComment').value,
              sCommentSSC: _thisCN.paytoCNForm.get('sCommentSSC').value,
            },
            TRequestItems: arr,
            FileUp: ArrFile,
            CommentDelete: this.sComment,
          }

          let Data = JSON.stringify(DataSave)

          let saveDaft = function () {
            _thisCN.System.BlockUI();
            _thisCN.isEditFromhome = false;
            const headers = new HttpHeaders({
              'Content-Type': 'application/json'
            });
            _thisCN.http.post(_thisCN.System.SiteName + "api/_Paytovendor/Save", Data, { headers, responseType: 'text' }).subscribe(s => {
              if (s == "Success") {
                ArrFile = [];
                _thisCN.System.UnBlockUI();
                _thisCN.SW.SwAlert.Success(_thisCN.SW.BoxMsg.Title_Success, _thisCN.SW.BoxMsg.Desc_SaveComplete, function () { _thisCN.router.navigate(["home"]) });
              } else {
                _thisCN.SW.SwAlert.Error(_thisCN.SW.BoxMsg.Title_Error, s, undefined)
                _thisCN.System.UnBlockUI();
              }
            });
          }
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Submit, saveDaft, function () { });
        } else {
          if (FieldValid.length != 0) {
            FieldValid.forEach(function (Field) {
              const control = _FormGroup.get(Field);
              //{3}
              if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
                control.markAsTouched({ onlySelf: true });
              }
            });
          }
          if (this.ArrRequestCN.filter(f => f.cActive != 'N').length == 0) {
            let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT", "sText"];
            for (let i = 0; i < this.ArrGL.length; i++) {
              FieldGLValid.forEach(function (Field) {
                let FromArray = _FormGroup.get('ArrGL') as FormArray;
                const control = FromArray.at(i).get(Field);             //{3}
                if (control instanceof FormControl && mode != 1 && control.status != "DISABLED") {             //{4}
                  control.markAsTouched({ onlySelf: true });
                }
              });
            }
          }
        }
      }
      else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
        _thisCN.clicked = false;
        return false;
      }
    }
    //Recall
    if (mode == 3) {
      let DataSave = {
        TRequest: {
          sRequestID: _thisCN.paytoCNForm.value.sRequestID,
          nStatusID: 3,
        }
      }
      let Data = JSON.stringify(DataSave)
      let SaveRecall = function () {
        _thisCN.isEditFromhome = false;
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _thisCN.http.post(_thisCN.System.SiteName + "api/_Paytovendor/Recall", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            _thisCN.SW.SwAlert.Success(_thisCN.SW.BoxMsg.Title_Success, _thisCN.SW.BoxMsg.Desc_SaveComplete, function () { _thisCN.router.navigate(["home"]) });
          }
        })
      }
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, SaveRecall, function () { });
    }
    _thisCN.clicked = false;

  }
  cancel() {
    let _thisCN = this;
    if (_thisCN.sComment === null || _thisCN.sComment === "") {
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else {
      let DataSave = {
        TRequest: {
          sRequestID: _thisCN.paytoCNForm.value.sRequestID,
          nStatusID: 0,
        },
        CommentDelete: this.sComment,
      }
      let Data = JSON.stringify(DataSave)
      let SaveRecall = function () {
        _thisCN.isEditFromhome = false;
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _thisCN.http.post(_thisCN.System.SiteName + "api/_Paytovendor/cancel", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            _thisCN.SW.SwAlert.Success(_thisCN.SW.BoxMsg.Title_Success, _thisCN.SW.BoxMsg.Desc_Success_Delete, function () { _thisCN.router.navigate(["home"]) });
          }
        })
      }
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, SaveRecall, function () { });
    }
  }
  async AddInvoice() {
    let _this = this;
    if (_IsNullOrEmpty(_this.paytoCNForm.get('sVendorName').value) || _IsNullOrEmpty(_this.paytoCNForm.get('sAddress').value) || _IsNullOrEmpty(_this.paytoCNForm.get('sTAXID').value)) {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
      return false;
    }
    let nTotalAmountVat: number = _ParseFloatToZero(this.paytoCNForm.controls['nTotalAmountVat'].value).toFixed(2);
    let nWHTBase: number = _ParseFloatToZero(this.paytoCNForm.controls['nWHTBase'].value).toFixed(2);
    let nWHTBase2: number = _ParseFloatToZero(this.paytoCNForm.controls['nWHTBase2'].value).toFixed(2);
    if (nTotalAmountVat > 0) nTotalAmountVat = nTotalAmountVat * -1
    if (nWHTBase > 0) nWHTBase = nWHTBase * -1
    if (nWHTBase2 > 0) nWHTBase2 = nWHTBase2 * -1

    let base = this._ConvertToDecimal((Number(nWHTBase) + Number(nWHTBase2)).toFixed(2));
    let totalAmount = this._ConvertToDecimal((Number(nTotalAmountVat)).toFixed(2));
    if (totalAmount !== base && base !== '0.00') {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Base_TotalNoMatch, undefined)
      return false;
    }

    //#region CheckValidate
    let vatType = this.paytoCNForm.value.ddVatType;
    let datavat = this.VatType.filter(s => s.TAX_CODE == vatType)[0]
    let _FormGroup = this.paytoCNForm;
    let IsValid: boolean = true;
    let FieldValid: string[];
    if (_FormGroup.get("nWHTOther").disabled == true || _FormGroup.get("nWHTOther2").disabled == true) {
      //FieldValid = ["sAddress", "sVendorName", "sTAXID", "sInvoiceNo", "sName", "dDueDate", "nVendorCode",
      //  , "dInvoiceDate", "nTotalAmountVat", "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode"
      //  , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail",];
      FieldValid = ["sAddress", "sVendorName", "sTAXID", "sInvoiceNo", "sName", "dDueDate", "nVendorCode",
        , "dInvoiceDate", "nTotalAmountVat", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
      //"sCountryID", "sProvName", "sAmpName", "sTumbonName", "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail"
    } else {
      //FieldValid = ["sAddress", "sInvoiceNo", "sName", "dDueDate", "nVendorCode", "sVendorName", "sTAXID",
      //  , "dInvoiceDate", "nTotalAmountVat", "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode"
      //  , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail", "nWHTOther"];
      FieldValid = ["sAddress", "sInvoiceNo", "sName", "dDueDate", "nVendorCode", "sVendorName", "sTAXID",
        , "dInvoiceDate", "nTotalAmountVat", "nWHTOther", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
      // "sCountryID", "sProvName", "sAmpName", "sTumbonName"  , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail",
    }
    FieldValid.forEach(function (Field) {
      if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled != true) {
        IsValid = false;
        return false;
      }
      //เช็ค ddTypeVat
      if (vatType != "-1") {
        if (!_FormGroup.get("nVatAmount").valid && datavat.TAX_CODE != "VZ") {
          const control = _FormGroup.get("nVatAmount");
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
            IsValid = false;
            return false;
          }
        }
      } else if (vatType == "-1") {
        const control = _FormGroup.get("nVatAmount");
        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
          _FormGroup.get("ddVatType").setErrors({ 'invalid': true })
          _FormGroup.get("ddVatType").markAsTouched({ onlySelf: true });
          IsValid = false;
          return false;
        }
      }
    });

    //เช็ค ArrGL
    if (IsValid) {
      let FieldGLValid: string[];
      FieldGLValid = ["sCostCenter", "sAmountExcludedVAT", "sText"];
      if (this.isUseIo) {
        FieldGLValid.push("sIO");
      }
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          if (!FromArray.at(i).get(Field).valid) {
            IsValid = false;
            return false;
          }
        });
      }
    }
    //#endregion
    if (IsValid) {
      let nWHTRate: any;
      let nWHTRate2: any;
      let arrGl = this.paytoCNForm.value.ArrGL;
      let InvoiceNo = this.paytoCNForm.get('sInvoiceNo').value;
      let VatType = this.paytoCNForm.get('ddVatType').value;
      let sVendorCode = this.paytoCNForm.get('nVendorCode').value;
      let sVendorName = this.paytoCNForm.get('sVendorName').value;
      let sTAXID = this.paytoCNForm.get('sTAXID').value;
      let sVendorBranch = this.paytoCNForm.get('sBranch').value;
      let sVendorAddress = this.paytoCNForm.get('sAddress').value;
      let dInvoiceDate = this.datepipe.transform(this.paytoCNForm.get('dInvoiceDate').value, 'dd/MM/yyyy')
      let sCurrency = this.paytoCNForm.get('ddCurrency').value;
      let nExcludeVAT = Number(this.paytoCNForm.get('nTotalAmountVat').value).toFixed(2);
      let nVatAmount = this.paytoCNForm.get('nVatAmount').value;
      let nIncludeVAT = this.paytoCNForm.get('nTotalAmountInvoice').value;
      let nWHTID = this.paytoCNForm.get('ddlWithholdingTax').value;
      let nWHTID2 = this.paytoCNForm.get('ddlWithholdingTax2').value;
      let nWHT = this.WHT.filter(f => f.nRate == nWHTID && nWHTID !== ' ')[0];
      let nWHT2 = this.WHT.filter(f => f.nRate == nWHTID2 && nWHTID2 !== ' ')[0];
      let nWHTVal = this.paytoCNForm.get('nWHTVal').value;
      let nWHTVal2 = this.paytoCNForm.get('nWHTVal2').value;
      let nWHTBase = this.paytoCNForm.get('nWHTBase').value;
      let nWHTBase2 = this.paytoCNForm.get('nWHTBase2').value;
      let sCountryID = this.paytoCNForm.get('sCountryID').value;
      let sProvCode = this.paytoCNForm.get('sProvCode').value;
      let sProvName = this.paytoCNForm.get('sProvName').value;
      let sAmpCode = this.paytoCNForm.get('sAmpCode').value;
      let sAmpName = this.paytoCNForm.get('sAmpName').value;
      let sTumbonCode = this.paytoCNForm.get('sTumbonCode').value;
      let sTumbonName = this.paytoCNForm.get('sTumbonName').value;
      let sPostCode = this.paytoCNForm.get('sPostCode').value;
      let sPhoneNumber = this.paytoCNForm.get('sPhoneNumber').value;
      let sFaxNumber = this.paytoCNForm.get('sFaxNumber').value;
      let sVendorEmail = this.paytoCNForm.get('sVendorEmail').value;
      let sAddressOneTime = this.paytoCNForm.get('sAddressOneTime').value;
      let nOfficeType = this.paytoCNForm.value.cbOffice;
      let IsVendorOneTime = this.IsVendorOneTime;
      if (nWHTID == '99' || nWHTID == '0') {
        nWHTRate = Number(this.paytoCNForm.get('nWHTOther').value);
      }
      else if (nWHTID == ' ') {
        nWHTRate = null;
      }
      else {
        nWHTRate = Number(this.paytoCNForm.get('nWHTRate').value);
      }
      if (nWHTID2 == '99' || nWHTID2 == '0') {
        nWHTRate2 = Number(this.paytoCNForm.get('nWHTOther2').value);
      }
      else if (nWHTID2 == ' ') {
        nWHTRate2 = null;
      }
      else {
        nWHTRate2 = Number(this.paytoCNForm.get('nWHTRate2').value);
      }
      let arrsum = arrGl.filter(f => f.IsDelete != true).map(m => this.Check2Digit(m.sAmountExcludedVAT));
      let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2)
      let _this = this;
      let isDup: Boolean;
      let checkDupInvoiceinBase = await this.checkDupinBase(InvoiceNo, dInvoiceDate)
      isDup = (checkDupInvoiceinBase == "Dup") ? true : false
      let CheckDupInvoice = this.ArrRequestCN.filter(m =>
        (m.sInvoiceNo == InvoiceNo && m.dInvoiceDate == dInvoiceDate && m.IsDelete == false)
      )
      if (CheckDupInvoice.length == 0 && isDup == false) {
        if (sumNumber == Number(_ParseFloatToZero(this.paytoCNForm.value.nTotalAmountVat).toFixed(2))) {
          let checkGL = arrGl.filter(f => f.IsDelete != true).map(m =>
            m.sGL,
          )
          let checkCostCenter = arrGl.filter(f => f.IsDelete != true).map(m =>
            m.sCostCenter,
          )
          let checkIO = arrGl.filter(f => f.IsDelete != true).map(m =>
            m.sIO,
          )
          /*          if ((checkGL.includes("") == false && checkCostCenter.includes("") == false && checkIO.includes("") == false)) {*/
          let wht: any;
          let wht2: any;
          if (nWHT == undefined || nWHT == null) {
            wht = null;
          } 
          if (nWHT2 == undefined || nWHT2 == null) {
            wht2 = null;
          } 
          if (nWHTID == 99) {
            wht = 99;
          } 
          if (nWHTID2 == 99) {
            wht2 = 99;
          } 
          if (nWHT != undefined || nWHT != null) {
            wht = nWHT.nWHTID;
          }
          if (nWHT2 != undefined || nWHT2 != null) {
            wht2 = nWHT2.nWHTID;
          }
          arrGl.filter(f => f.IsDelete != true).forEach(function (value, i: number) {
            let nLine = (_this.ArrRequestCN.length >= 1) ? _this.ArrRequestCN.filter(f => (f.sInvoiceNo == InvoiceNo && f.dInvoiceDate == dInvoiceDate && f.IsDelete == false)).length : 0;
            let arr = {
              sInvoiceNo: InvoiceNo,
              sVatType: VatType,
              nLine: nLine + 1,
              sGL: value.sGL,
              sCostCenter: value.sCostCenter,
              sIO: value.sIO === "Not Require IO (N/A)" ? null : value.sIO,
              sAmount: _ParseFloatToZero(value.sAmountExcludedVAT) * -1,
              sText: value.sText,
              cVenderMaster: "M",
              sVendorCode: sVendorCode,
              sVendorName: sVendorName,
              sTAXID: sTAXID,
              sVendorBranch: sVendorBranch,
              sVendorAddress: sVendorAddress,
              dInvoiceDate: dInvoiceDate,
              sCurrency: sCurrency,
              nExcludeVAT: _ParseFloatToZero(nExcludeVAT),
              nVAT: _ParseFloatToZero(nVatAmount),
              nIncludeVAT: _ParseFloatToZero(nIncludeVAT),
              nWHTID: wht,
              nWHTID2: wht2,
              nWHTRate: +nWHTRate,
              nWHTRate2: +nWHTRate2,
              nWHTVal: _ParseFloatToZero(nWHTVal),
              _nWHTVal: _ParseFloatToZero(nWHTVal),
              nWHTVal2: _ParseFloatToZero(nWHTVal2),
              _nWHTVal2: _ParseFloatToZero(nWHTVal2),
              nWHTBase: _ParseFloatToZero(nWHTBase),
              nWHTBase2: _ParseFloatToZero(nWHTBase2),
              nOfficeType: nOfficeType,
              nInvoiceType: null,
              sCountryID: sCountryID,
              sProvCode: sProvCode,
              sProvName: sProvName,
              sAmpCode: sAmpCode,
              sAmpName: sAmpName,
              sTumbonCode: sTumbonCode,
              sTumbonName: sTumbonName,
              sPostCode: sPostCode,
              sPhoneNumber: sPhoneNumber,
              sFaxNumber: sFaxNumber,
              sVendorEmail: sVendorEmail,
              sAddressOneTime: sAddressOneTime,
              IsVendorOneTime: IsVendorOneTime,
              dCreateDate: null,
              sCreateBy: "",
              dUpdateDate: null,
              IsDelete: false,
            };
            _this.ArrRequestCN.push(arr);
          })
          this.CalGrand();
          this.Checkinvoice();
          this.clearSubinvoice();

          //#region 2021-01-21 Log Save Invoice
          // const options = { headers: { 'Content-Type': 'application/json' } };
          // _this.http.post<any>(_this.System.SiteName + "api/_Paytovendor/LogInvoice", JSON.stringify(_this.ArrInvoice), options).subscribe(res => {

          // })
          //#endregion

          /*    } else {
                this.SW.SwAlert.Warning(this.SW.BoxMsg.Title_info, "!!!!!!!!!", undefined)
              }*/

        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
          return false;
        }
      } else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
      }
    } else {
      FieldValid.forEach(function (Field) {
        const control = _FormGroup.get(Field);             //{3}
        if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
          control.markAsTouched({ onlySelf: true });
        }
      });
      let FieldGLValid: string[];
      FieldGLValid = ["sCostCenter", "sAmountExcludedVAT", "sText"];
      if (this.isUseIo) {
        FieldGLValid.push("sIO");
      }
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          const control = FromArray.at(i).get(Field);             //{3}
          if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
            control.markAsTouched({ onlySelf: true });
          }
        });
      }
    }
  }
  ClearInvoice() {
    this.paytoCNForm.controls['nVatAmount'].enable();
    this.paytoCNForm.controls["nVatAmount"].setValidators([Validators.required]);
    this.paytoCNForm.controls["nVatAmount"].updateValueAndValidity();
    this.paytoCNForm.controls['nWHTOther'].disable();
    this.paytoCNForm.controls['nWHTOther2'].disable();
    let _this = this;
    this.isEdit = false;
    let FieldValid: string[] = ["nVatAmount", "sTAXID", "sVendorName", "sInvoiceNo", "nVendorCode", "dInvoiceDate", "ddVatType", "nTotalAmountVat", "nBankAccountNo", "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode"
      , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail"];
    for (let i = 0; i < FieldValid.length; i++) {
      _this.paytoCNForm.get(FieldValid[i]).markAsUntouched();
    }
    let sCurrency = _this.ArrRequestCN.filter(f => f.IsDelete != true).length > 0 ? _this.paytoCNForm.get("ddCurrency").value : "THB"
    if (_this.ArrRequestCN.filter(f => f.IsDelete != true).length == 0) {
      this.paytoCNForm.patchValue({
        nVendorCode: "",
        sTAXID: "",
        sVendorName: "",
        cbOffice: 1,
        sBranch: "",
        sAddress: "",
        sCountryID: "",
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        ddBankKey: "",
        nBankKey: "",
        ddBankKey2: "",
        nBankKey2: "",
      });
      this.paytoCNForm.controls['ddBankKey2'].disable();
    } else {
      this.paytoCNForm.patchValue({
        //nVendorCode: "",
        sInvoiceNo: null,
        dInvoiceDate: new Date(),
        nTotalAmount: null,
        ddCurrency: sCurrency,
        nVat: null,
        ddVatType: "-1",
        nVatAmount: null,
        nTotalAmountInvoice: null,
        nTotalAmountVat: null,
        ddlWithholdingTax: " ",
        ddlWithholdingTax2: " ",
        nWHTRate: null,
        nWHTRate2: null,
        nWHTOther: null,
        nWHTOther2: null,
        nWHTVal: null,
        _nWHTVal: null,
        nWHTVal2: null,
        _nWHTVal2: null,
        nWHTBase: null,
        nWHTBase2: null,
      })
      if (this.paytoCNForm.get('cbOffice').value == 1) {
        this.paytoCNForm.controls['sBranch'].disable();
      }
    }
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.clear()
    this._paytoCNForm.ArrGL.reset();
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl('', Validators.required),
      sIO: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl(''),
      nline: new FormControl('')
    }))
    this.checkUseIo();
    this.checkUseGL();

  }
  DeleteInvoice(sInvoiceNo, index) {
    let _thisCN1 = this;
    let del = function () {
      let invoice = _thisCN1.ArrRequestCN[index]
      invoice.cActive = "N";
      invoice.IsDelete = true;
      invoice.nLine = (invoice.nLine == null) ? 1 : invoice.nLine;

      _thisCN1.CalGrand();
      _thisCN1.Checkinvoice();
    }
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, del, function () { });
  }
  async EditInvoice(index, save) {
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    let _thisCN = this;
    if (!save) {
      document.getElementById('nVendorCode').scrollIntoView({ behavior: "smooth" });
      this.ArrGL.clear()
      this._paytoCNForm.ArrGL.reset();
      this.nEditindex = index;
      this.isEdit = true;
      let data = this.ArrRequestCN[index];
      let arrData = this.ArrRequestCN.filter(f => f.sInvoiceNo == data.sInvoiceNo && f.dInvoiceDate == data.dInvoiceDate)
      this.EditInvoiceCode = data.sInvoiceNo;
      this.EditInvoiceDate = data.dInvoiceDate;
      let myDate = data.dInvoiceDate;
      let chunks = myDate.split('/');
      let dInvoiceDate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
      let nVat = '';
      if (this.VatType.filter(s => s.TAX_CODE == data.sVatType).length > 0) {
        nVat = this.VatType.filter(s => s.TAX_CODE == data.sVatType)[0].nVAT;
      }
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", data.sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", data.sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let nWHT = this.WHT.filter(f => f.nWHTID == data.nWHTID)[0];
      let nWHT2 = this.WHT.filter(f => f.nWHTID == data.nWHTID2)[0];
      let ddlWithholdingTax: any;
      let ddlWithholdingTax2: any;

      if (data.nWHTID == null || data.nWHTID == " " || data.nWHTID == "") {
        ddlWithholdingTax = " ";
      }
      if (data.nWHTID2 == null || data.nWHTID2 == " " || data.nWHTID2 == "") {
        ddlWithholdingTax2 = " ";
      }
      if (data.nWHTID == 99) {
        ddlWithholdingTax = 99;
      }
      if (data.nWHTID2 == 99) {
        ddlWithholdingTax2 = 99;
      }
      if (data.nWHTID != null && data.nWHTID != 99 && data.nWHTID != "null") {
        if (nWHT != undefined) ddlWithholdingTax = nWHT.nRate
      }
      if (data.nWHTID2 != null && data.nWHTID2 != 99 && data.nWHTID2 != "null") {
        if (nWHT2 != undefined) ddlWithholdingTax2 = nWHT2.nRate
      }

      let nWHTRate: any;
      let nWHTRate2: any;
      if (data.nWHTID == "0" || data.nWHTID == null) {
        nWHTRate = null;
      } 
      if (data.nWHTID2 == "0" || data.nWHTID2 == null) {
        nWHTRate2 = null;
      } 
      if (data.nWHTID == 99 || data.nWHTID == 6) {
        nWHTRate = data.nWHTRate
      } 
      if (data.nWHTID2 == 99 || data.nWHTID2 == 6) {
        nWHTRate2 = data.nWHTRate2
      } 
      if ((data.nWHTID != "0" || data.nWHTID != null) && data.nWHTID != 99 && data.nWHTID != 6) {
        nWHTRate = null;
      }
      if ((data.nWHTID2 != "0" || data.nWHTID2 != null) && data.nWHTID2 != 99 && data.nWHTID2 != 6) {
        nWHTRate2 = null;
      }

      this.paytoCNForm.patchValue({
        sTumbonCode: data.sTumbonCode,
        sTumbonName: data.sTumbonName,
        sPostCode: data.sPostCode,
        sPhoneNumber: data.sPhoneNumber,
        sAmpCode: data.sAmpCode,
        sAmpName: data.sAmpName,
        nTotalAmount: data.sAmount,
        cbOffice: data.nOfficeType,
        sBranch: data.sVendorBranch,
        sAddress: data.sVendorAddress,
        sFaxNumber: data.sFaxNumber,
        sVendorEmail: data.sVendorEmail,
        sAddressOneTime: data.sAddressOneTime,
        sInvoiceNo: data.sInvoiceNo,
        sCountryID: data.sCountryID,
        sProvCode: data.sProvCode,
        sProvName: data.sProvName,
        sVendorName: data.sVendorName,
        nTotalAmountInvoice: (!isNullOrUndefined(data.nIncludeVAT) ? _thisCN._ConvertToDecimal(data.nIncludeVAT) : 0),
        nTotalAmountVat: (!isNullOrUndefined(data.nExcludeVAT) ? _thisCN._ConvertToDecimal(data.nExcludeVAT) : 0),
        ddlWithholdingTax: ddlWithholdingTax,
        ddlWithholdingTax2: ddlWithholdingTax2,
        nWHTRate: data.nWHTRate == 0 ? " " : data.nWHTRate,
        nWHTRate2: data.nWHTRate2 == 0 ? " " : data.nWHTRate2,
        nWHTOther: nWHTRate,
        nWHTOther2: nWHTRate2,
        dInvoiceDate: dInvoiceDate,
        nVendorCode: data.sVendorCode,
        sTAXID: data.sTAXID,
        ddVatType: data.sVatType,
        nVatAmount: (!isNullOrUndefined(data.nVAT) ? _thisCN._ConvertToDecimal(data.nVAT) : 0),
        ddCurrency: data.sCurrency,
        nVat: nVat,
        nWHTVal: (!isNullOrUndefined(data.nWHTVal) ? _thisCN._ConvertToDecimal(data.nWHTVal) : '0.00'),
        _nWHTVal: (!isNullOrUndefined(data.nWHTVal) ? _thisCN._ConvertToDecimal(data.nWHTVal) : '0.00'),
        nWHTVal2: (!isNullOrUndefined(data.nWHTVal2) ? _thisCN._ConvertToDecimal(data.nWHTVal2) : '0.00'),
        _nWHTVal2: (!isNullOrUndefined(data.nWHTVal2) ? _thisCN._ConvertToDecimal(data.nWHTVal2) : '0.00'),
        nWHTBase: (!isNullOrUndefined(data.nWHTBase) ? _thisCN._ConvertToDecimal(data.nWHTBase) : 0),
        nWHTBase2: (!isNullOrUndefined(data.nWHTBase2) ? _thisCN._ConvertToDecimal(data.nWHTBase2) : 0),
      })
      this.Editsetvat();
      this.onWithholdingTaxSelect(1, false);
      this.onWithholdingTaxSelect(2, false);
      let num = 0;
      arrData.forEach(function (arrGL, i) {
        _thisCN.ArrMaster = [];
        _thisCN.ArrMaster.push(_thisCN.ArrIO);
        _thisCN.ArrGL.push(new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl('', Validators.required),
          sIO: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(''),
          sInvoiceNo: new FormControl(''),
          nline: new FormControl('')
        }))
        _thisCN.ArrGL.at(num).patchValue({
          sGL: arrGL.sGL,
          sCostCenter: arrGL.sCostCenter,
          sIO: arrGL.sIO === null ? "Not Require IO (N/A)" : arrGL.sIO,
          sAmountExcludedVAT: _thisCN._ConvertToDecimal(arrGL.sAmount),
          sText: arrGL.sText,
          IsDelete: arrGL.cActive == "N" ? true : false,
          sInvoiceNo: arrGL.sInvoiceNo,
          nline: arrGL.nLine
        })
        const httpOptions_IO = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sCompCode", _thisCN.nComcode)
        };
        _thisCN.http.get(_thisCN.System.SiteName + "api/_System/GetIO2", httpOptions_IO).subscribe((data: Response) => {
          _thisCN.DataIO = data;
          if (_thisCN.DataIO != null) {
            _thisCN.ArrIO = _thisCN.DataIO;
            _thisCN.ArrMaster[i] = _thisCN.ArrIO;
          } else {
            _thisCN.ArrMaster[i] = _thisCN.ArrIO;
          }
        })
        num++;
      });
      this.checkUseIo();
      this.checkUseGL();
      this.CalGrand();
      this.paytoCNForm.controls['ddCurrency'].enable();
    }
    if (save) {
      let pass = true;
      if (_IsNullOrEmpty(_thisCN.paytoCNForm.get('sVendorName').value) || _IsNullOrEmpty(_thisCN.paytoCNForm.get('sAddress').value) || _IsNullOrEmpty(_thisCN.paytoCNForm.get('sTAXID').value)) {
        _thisCN.SW.SwAlert.Error(_thisCN.SW.BoxMsg.Title_Error, _thisCN.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
        return false;
      }
      let nTotalAmountVat: number = _ParseFloatToZero(this.paytoCNForm.controls['nTotalAmountVat'].value).toFixed(2);
      let nWHTBase: number = _ParseFloatToZero(this.paytoCNForm.controls['nWHTBase'].value).toFixed(2);
      let nWHTBase2: number = _ParseFloatToZero(this.paytoCNForm.controls['nWHTBase2'].value).toFixed(2);
      nTotalAmountVat = -Math.abs(nTotalAmountVat);
      let base = this._ConvertToDecimal((Number(nWHTBase) + Number(nWHTBase2)).toFixed(2));
      let totalAmount = this._ConvertToDecimal((Number(nTotalAmountVat)).toFixed(2));
  
      if (totalAmount !== base && base !== '0.00') {
        _thisCN.SW.SwAlert.Error(_thisCN.SW.BoxMsg.Title_Error, _thisCN.SW.BoxMsg.Desc_Base_TotalNoMatch, undefined)
        return false;
      }
      let _FormGroup = this.paytoCNForm;
      let FieldGLValid: string[];
      FieldGLValid = ["sCostCenter", "sAmountExcludedVAT", "sText"];
      if (this.isUseIo) {
        FieldGLValid.push("sIO");
      }
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          if (!FromArray.at(i).get(Field).valid) {
            pass = false;
            return false;
          }
        });
      }
      if (pass) {
        let dInvoiceDate = this.datepipe.transform(this.paytoCNForm.get('dInvoiceDate').value, 'dd/MM/yyyy')
        let InvoiceNo = this.paytoCNForm.get('sInvoiceNo').value;
        let arrGl = this.paytoCNForm.value.ArrGL;
        let arrsum = arrGl.filter(f => f.IsDelete != true).map(m => Number(_ParseFloatToZero(m.sAmountExcludedVAT).toFixed(2)));
        let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2);
        let isDup: Boolean;
        let checkDupInvoiceinBase = await this.EditcheckDupinBase(InvoiceNo, dInvoiceDate, this.sReqID)
        isDup = (checkDupInvoiceinBase == "Dup") ? true : false
        let tempArr = [];
        this.ArrRequestCN.forEach(val => tempArr.push(Object.assign({}, val)));
        while (tempArr.findIndex(e => e.sInvoiceNo === _thisCN.EditInvoiceCode && e.dInvoiceDate === _thisCN.EditInvoiceDate) >= 0)
          tempArr.splice(tempArr.findIndex(f => f.sInvoiceNo === _thisCN.EditInvoiceCode && f.dInvoiceDate === _thisCN.EditInvoiceDate), 1);
        let CheckDupInvoice = tempArr.filter(m =>
          (m.sInvoiceNo == InvoiceNo && m.dInvoiceDate == dInvoiceDate && m.IsDelete == false)
        )
        if (CheckDupInvoice.length == 0 && isDup == false) {
          if (Math.abs(sumNumber).toFixed(2) == Math.abs(Number(_ParseFloatToZero(this.paytoCNForm.value.nTotalAmountVat))).toFixed(2)) {
            let _thisCN = this;
            let nWHTRate: any;
            let nWHTRate2: any;
            let data = this.ArrRequestCN[index];
            arrGl.forEach(function (value, num) {
              let nline = value.nline;
              let arrData = _thisCN.ArrRequestCN.filter(f => f.sInvoiceNo == _thisCN.EditInvoiceCode && f.dInvoiceDate == _thisCN.EditInvoiceDate && f.nLine == nline)
              if (arrData.length > 0) {
                arrData.forEach(function (value, i) {
                  value.nExcludeVAT = -Math.abs(Number(_ParseFloatToZero(_thisCN.paytoCNForm.value.nTotalAmountVat).toFixed(2)));
                  value.nVAT = _ParseFloatToZero(_thisCN.paytoCNForm.get('nVatAmount').value);
                  value.nIncludeVAT = _ParseFloatToZero(_thisCN.paytoCNForm.get('nTotalAmountInvoice').value);
                  value.sCountryID = _thisCN.paytoCNForm.get('sCountryID').value
                  value.sProvCode = _thisCN.paytoCNForm.get('sProvCode').value;
                  value.ntype = _thisCN.paytoCNForm.get('ntype').value;
                  value.sInvoiceNo = _thisCN.paytoCNForm.get('sInvoiceNo').value;
                  value.sVatType = _thisCN.paytoCNForm.get('ddVatType').value;
                  value.sText = arrGl[num].sText;
                  value.sGL = arrGl[num].sGL;
                  value.sCostCenter = arrGl[num].sCostCenter;
                  value.sIO = arrGl[num].sIO === "Not Require IO (N/A)" ? null : arrGl[num].sIO;
                  value.sFaxNumber = _thisCN.paytoCNForm.get('sFaxNumber').value;
                  value.sVendorEmail = _thisCN.paytoCNForm.get('sVendorEmail').value;
                  value.sVendorBranch = _thisCN.paytoCNForm.get('sBranch').value;
                  value.sVendorAddress = _thisCN.paytoCNForm.get('sAddress').value;
                  value.dInvoiceDate = _thisCN.datepipe.transform(_thisCN.paytoCNForm.get('dInvoiceDate').value, 'dd/MM/yyyy');
                  value.sCurrency = _thisCN.paytoCNForm.get('ddCurrency').value;
                  value.sAmount = -Math.abs(Number(_ParseFloatToZero(arrGl[num].sAmountExcludedVAT).toFixed(2)));
                  value.nLine = (nline == null) ? 1 : nline;
                  value.nOfficeType = _thisCN.paytoCNForm.get('cbOffice').value;
                  value.sVendorCode = _thisCN.paytoCNForm.get('nVendorCode').value;
                  value.sVendorName = _thisCN.paytoCNForm.get('sVendorName').value;
                  value.sTAXID = _thisCN.paytoCNForm.get('sTAXID').value;
                  value.sAmpCode = _thisCN.paytoCNForm.get('sAmpCode').value;
                  value.sTumbonCode = _thisCN.paytoCNForm.get('sTumbonCode').value;
                  value.sPostCode = _thisCN.paytoCNForm.get('sPostCode').value;
                  value.IsDelete = arrGl[num].IsDelete;
                  value.cActive = arrGl[num].IsDelete == true ? 'N' : 'Y';
                  value.sPhoneNumber = _thisCN.paytoCNForm.get('sPhoneNumber').value;

                  if (_thisCN.paytoCNForm.get('ddlWithholdingTax').value != 0) {

                    nWHTRate = Number(_thisCN.paytoCNForm.get('nWHTRate').value);
                  } else {
                    nWHTRate = Number(_thisCN.paytoCNForm.get('nWHTOther').value);
                  }
                  if (_thisCN.paytoCNForm.get('ddlWithholdingTax2').value != 0) {

                    nWHTRate2 = Number(_thisCN.paytoCNForm.get('nWHTRate2').value);
                  } else {
                    nWHTRate2 = Number(_thisCN.paytoCNForm.get('nWHTOther2').value);
                  }
                  let nWHT = _thisCN.WHT.filter(f => f.nRate == _thisCN.paytoCNForm.get('ddlWithholdingTax').value && _thisCN.paytoCNForm.get('ddlWithholdingTax').value !== ' ')[0];
                  let nWHT2 = _thisCN.WHT.filter(f => f.nRate == _thisCN.paytoCNForm.get('ddlWithholdingTax2').value && _thisCN.paytoCNForm.get('ddlWithholdingTax2').value !== ' ')[0];
                  
                  let nWHTID: any;
                  let nWHTID2: any;
                  if (nWHT == null || nWHT == " " || nWHT == "" || nWHT == undefined) {
                    nWHTID = null;
                    if (_thisCN.paytoCNForm.get('ddlWithholdingTax').value == 99) {
                      nWHTID = 99;
                    }
                  }
                  else {
                    if (_thisCN.paytoCNForm.get('ddlWithholdingTax').value == 99) {
                      nWHTID = 99;
                    } if (nWHT != null) {
                      nWHTID = nWHT.nWHTID;
                    }
                  }
                  if (nWHT2 == null || nWHT2 == " " || nWHT2 == "" || nWHT2 == undefined) {
                    nWHTID2 = null;
                    if (_thisCN.paytoCNForm.get('ddlWithholdingTax2').value == 99) {
                      nWHTID2 = 99;
                    }
                  }
                  else {
                    if (_thisCN.paytoCNForm.get('ddlWithholdingTax2').value == 99) {
                      nWHTID2 = 99;
                    } if (nWHT2 != null) {
                      nWHTID2 = nWHT2.nWHTID;
                    }
                  }

                  //    let nWHTRate: any;
                  if (_thisCN.paytoCNForm.get('ddlWithholdingTax').value == "0" || _thisCN.paytoCNForm.get('ddlWithholdingTax').value == null) {
                    nWHTRate = Number(_thisCN.paytoCNForm.get('nWHTRate').value);
                  } 
                  if (_thisCN.paytoCNForm.get('ddlWithholdingTax2').value == "0" || _thisCN.paytoCNForm.get('ddlWithholdingTax2').value == null) {
                    nWHTRate2 = Number(_thisCN.paytoCNForm.get('nWHTRate2').value);
                  } 
                  if (_thisCN.paytoCNForm.get('ddlWithholdingTax').value == 99 || _thisCN.paytoCNForm.get('ddlWithholdingTax').value == 6) {
                    nWHTRate = Number(_thisCN.paytoCNForm.get('nWHTOther').value);
                  }
                  if (_thisCN.paytoCNForm.get('ddlWithholdingTax2').value == 99 || _thisCN.paytoCNForm.get('ddlWithholdingTax2').value == 6) {
                    nWHTRate2 = Number(_thisCN.paytoCNForm.get('nWHTOther2').value);
                  }

                  value.nWHTID = nWHTID == null ? null : nWHTID;
                  value.nWHTID2 = nWHTID2 == null ? null : nWHTID2;
                  value.nWHTRate = nWHTRate;
                  value.nWHTRate2 = nWHTRate2;
                  value.nWHTVal = _thisCN.paytoCNForm.get('nWHTVal').value;
                  value.nWHTVal2 = _thisCN.paytoCNForm.get('nWHTVal2').value;
                  value.nWHTBase = _thisCN.paytoCNForm.get('nWHTBase').value;
                  value.nWHTBase2 = _thisCN.paytoCNForm.get('nWHTBase2').value;
                })
              } else {

                let nWHT = _thisCN.WHT.filter(f => f.nRate == _thisCN.paytoCNForm.get('ddlWithholdingTax').value && _thisCN.paytoCNForm.get('ddlWithholdingTax').value !== ' ')[0];
                let nWHT2 = _thisCN.WHT.filter(f => f.nRate == _thisCN.paytoCNForm.get('ddlWithholdingTax2').value && _thisCN.paytoCNForm.get('ddlWithholdingTax2').value !== ' ')[0];
                
                let nWHTID: any;
                let nWHTID2: any;
                if (nWHT == null || nWHT == " " || nWHT == "") {
                  nWHTID = null;
                }
                else {
                  if (_thisCN.paytoCNForm.get('ddlWithholdingTax').value == 99) {
                    nWHTID = 99;
                  } if (nWHT != null) {
                    nWHTID = nWHT.nWHTID;
                  }
                }
                if (nWHT2 == null || nWHT2 == " " || nWHT2 == "") {
                  nWHTID2 = null;
                }
                else {
                  if (_thisCN.paytoCNForm.get('ddlWithholdingTax2').value == 99) {
                    nWHTID2 = 99;
                  } if (nWHT != null) {
                    nWHTID2 = nWHT.nWHTID;
                  }
                }

                if (_thisCN.paytoCNForm.get('ddlWithholdingTax').value != 0) {
                  nWHTRate = Number(_thisCN.paytoCNForm.get('nWHTRate').value);
                } 
                if (_thisCN.paytoCNForm.get('ddlWithholdingTax2').value != 0) {
                  nWHTRate2 = Number(_thisCN.paytoCNForm.get('nWHTRate2').value);
                } 
                if (_thisCN.paytoCNForm.get('ddlWithholdingTax2').value == 99) {
                  nWHTRate2 = Number(_thisCN.paytoCNForm.get('nWHTOther2').value);
                }
                let arr = {
                  sCurrency: _thisCN.paytoCNForm.get('ddCurrency').value,
                  nExcludeVAT: Number(_ParseFloatToZero(_thisCN.paytoCNForm.value.nTotalAmountVat).toFixed(2)),
                  nVAT: _ParseFloatToZero(_thisCN.paytoCNForm.get('nVatAmount').value),
                  nIncludeVAT: _ParseFloatToZero(_thisCN.paytoCNForm.get('nTotalAmountInvoice').value),
                  cActive: arrGl[num].IsDelete == true ? 'N' : 'Y',
                  ntype: _thisCN.paytoCNForm.get('ntype').value,
                  sVendorCode: _thisCN.paytoCNForm.get('nVendorCode').value,
                  sVendorName: _thisCN.paytoCNForm.get('sVendorName').value,
                  sTAXID: _thisCN.paytoCNForm.get('sTAXID').value,
                  sVendorBranch: _thisCN.paytoCNForm.get('sBranch').value,
                  sVendorAddress: _thisCN.paytoCNForm.get('sAddress').value,
                  dInvoiceDate: _thisCN.datepipe.transform(_thisCN.paytoCNForm.get('dInvoiceDate').value, 'dd/MM/yyyy'),
                  sCountryID: _thisCN.paytoCNForm.get('sCountryID').value,
                  nWHTID: nWHTID == null ? null : nWHTID,
                  nWHTID2: nWHTID2 == null ? null : nWHTID2,
                  nWHTRate: _ParseFloatToZero(nWHTRate),
                  nWHTRate2: _ParseFloatToZero(nWHTRate2),
                  nWHTVal: _ParseFloatToZero(_thisCN.paytoCNForm.get('nWHTVal').value),
                  _nWHTVal: _ParseFloatToZero(_thisCN.paytoCNForm.get('nWHTVal').value),
                  nWHTVal2: _ParseFloatToZero(_thisCN.paytoCNForm.get('nWHTVal2').value),
                  _nWHTVal2: _ParseFloatToZero(_thisCN.paytoCNForm.get('nWHTVal2').value),
                  nWHTBase: _ParseFloatToZero(_thisCN.paytoCNForm.get('nWHTBase').value),
                  nWHTBase2: _ParseFloatToZero(_thisCN.paytoCNForm.get('nWHTBase2').value),
                  nOfficeType: _thisCN.paytoCNForm.get('cbOffice').value,
                  nInvoiceType: null,
                  sInvoiceNo: _thisCN.paytoCNForm.get('sInvoiceNo').value,
                  sVatType: _thisCN.paytoCNForm.get('ddVatType').value,
                  nLine: _thisCN.ArrRequestCN.filter(f => f.sInvoiceNo == data.sInvoiceNo && f.dInvoiceDate == data.dInvoiceDate).length + 1,
                  sGL: arrGl[num].sGL,
                  sCostCenter: arrGl[num].sCostCenter,
                  sIO: arrGl[num].sIO,
                  sText: arrGl[num].sText,
                  sAmount: -Math.abs(_ParseFloatToZero(arrGl[num].sAmountExcludedVAT)),
                  cVenderMaster: "M",
                  sTumbonCode: _thisCN.paytoCNForm.get('sTumbonCode').value,
                  sProvCode: _thisCN.paytoCNForm.get('sProvCode').value,
                  sAmpCode: _thisCN.paytoCNForm.get('sAmpCode').value,
                  sPhoneNumber: _thisCN.paytoCNForm.get('sPhoneNumber').value,
                  sPostCode: _thisCN.paytoCNForm.get('sPostCode').value,
                  sEmail: _thisCN.paytoCNForm.get('sVendorEmail').value,
                  sFaxNumber: _thisCN.paytoCNForm.get('sFaxNumber').value,
                  sCreateBy: "",
                  dCreateDate: null,
                  IsDelete: false,
                  dUpdateDate: null,
                }
                _thisCN.ArrRequestCN.push(arr);
              }
            })
            this.clearSubinvoice();
            this.CalGrand();
            this.Checkinvoice();
            const options = { headers: { 'Content-Type': 'application/json' } };
            _thisCN.http.post<any>(_thisCN.System.SiteName + "api/_Paytovendor/LogInvoice", JSON.stringify(_thisCN.ArrRequestCN), options).subscribe(res => {

            })
          }
          else {
            this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
            return false;
          }
        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
          return false;
        }
      } else {
        let FieldGLValid: string[];
        FieldGLValid = ["sCostCenter", "sAmountExcludedVAT", "sText"];
        if (this.isUseIo) {
          FieldGLValid.push("sIO");
        }
        if (this.isUseGL) {
          FieldGLValid.push("sGL");
        }
        for (let i = 0; i < this.ArrGL.length; i++) {
          FieldGLValid.forEach(function (Field) {
            let FromArray = _FormGroup.get('ArrGL') as FormArray;
            const control = FromArray.at(i).get(Field);             //{3}
            if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
      }
    }
  }
  async onBankBranchSelect(event) {
    var valueCheck = this.paytoCNForm.hasOwnProperty('nBankKey2');
    this.paytoCNForm.patchValue({
      ddBankKey: event.item.NAME_OF_BANK,
      nBankKey: event.item.BANK_KEY,
      ddBankKey2: this.paytoCNForm.get('nBankKey').value === event.item.BANK_KEY && valueCheck ? this.paytoCNForm.get('nBankKey2').value : "",
      nBankKey2: this.paytoCNForm.get('nBankKey').value === event.item.BANK_KEY && valueCheck ? this.paytoCNForm.get('nBankKey2').value : "",
    })
    this.paytoCNForm.controls['ddBankKey2'].enable();

    if (event.item.NAME_OF_BANK == "N/A") {
      this.DataBankBranch2 = [{ Show: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
    }
    else {
      await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/VENDOR_CODE/" + this.paytoCNForm.get('nVendorCode').value + "/BANK/" + event.item.BANK_KEY + "/PARTNER_BANK/ASC").toPromise().then((data: any) => {
        this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
      })
    }
    if (this.DataBankBranch2.length > 0) {
      this.paytoCNForm.patchValue({
        ddBankKey2: this.DataBankBranch2[0].BANK_ACCOUNT,
        nBankKey2: this.DataBankBranch2[0].BANK_ACCOUNT,
      })
    }
  }

  onBankBranchSelect2(event) {
    this.paytoCNForm.patchValue({
      ddBankKey2: event.item.BANK_ACCOUNT,
      nBankKey2: event.item.BANK_ACCOUNT,
    })
  }
  onApprover1(value) {
    let ckNull = this.paytoCNForm.get('ddApprover1').value;
    let ischeck = this.ArrApprover[0].filter(f => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.paytoCNForm.patchValue({
        sApprove1: null,
      })
    } else if (this.Approve1NoResult == false && !isNullOrUndefined(ischeck)) {
      this.paytoCNForm.patchValue({
        sApprove1: value.item.nUserID,
      })
    } else if (this.Approve1NoResult == false && isNullOrUndefined(ischeck)) {
      this.paytoCNForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      })
    }
    if (this.Approve1NoResult == true) {
      this.paytoCNForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      })
    }
  }
  onApprover2(value) {
    let ckNull = this.paytoCNForm.get('ddApprover2').value;
    let ischeck = this.ArrApprover[1].filter(f => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.paytoCNForm.patchValue({
        sApprove2: null,
      })
    } else if (this.Approve2NoResult == false && !isNullOrUndefined(ischeck)) {
      this.paytoCNForm.patchValue({
        sApprove2: value.item.nUserID,
      })
    }
    else if (this.Approve2NoResult == false && isNullOrUndefined(ischeck)) {
      this.paytoCNForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      })
    }
    if (this.Approve2NoResult == true) {
      this.paytoCNForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      })
    }
  }

  onSubmit() {


  }

  //***********Save*****************


  checkUseIo() {
    let _thisCN = this;
    if (this.isUseIo) {
      _thisCN.IsNotFill_IO = false;
      _thisCN.ArrGL.controls.forEach(function (row) {
        row.get('sIO').enable();


      })
    } else {
      _thisCN.IsNotFill_IO = true;
      _thisCN.ArrGL.controls.forEach(function (row) {
        row.get('sIO').disable();
      })
    }
  }


  //***********EditFormHome*****************
  async Edit(sReqID) {
    let _thisCN = this;
    //_thisCN.DataBankBranch = [];
    const ua = this.System.GetUserStorage();
    this.System.BlockUI();
    let Isnull = sReqID == "" ? true : false;
    if(this.isForROS) Isnull = true;
    if (ua.IsROService && Isnull) {
      this.isReject = true;
    }
    if (!Isnull) { // เช็คว่า ใบใหม่หรือใบเก่า
      _thisCN.paytoCNForm.patchValue({ sRequestID: sReqID });
      _thisCN.isDraft = true;
      _thisCN.isPrint = true;
      _thisCN.haveComments = true;
      await this.http.get(this.System.SiteName + "api/Autocomplete/TRequest/sRequestCode/sRequestID/" + sReqID + "").toPromise().then(Data => {
        if (Data) {
          if (!isNullOrUndefined(Data[0].sRequestCode) && Data[0].sRequestCode != "") {
            _thisCN.sReqCode = Data[0].sRequestCode;
            _thisCN.haveRequestCode = true;
          }
        }
      })
      //await this.http.get(this.System.SiteName + "api/_Paytovendor/CheckReject/" + sReqID + "").toPromise().then(Data => {
      //  if (Data) {
      //    if (!isNullOrUndefined(Data[0].sComment) && Data[0].sComment != "") {
      //      _thisCN.sComment = Data[0].sComment;
      //      _thisCN.paytoCNForm.patchValue({
      //        sComment: Data[0].sComment,
      //      })
      //    }
      //  }
      //})
      let _FormGroup = this.paytoCNForm;
      this.ArrMaster = [];
      this.ArrMaster.push(this.ArrIO);
      this.ArrGL.clear();
      this._paytoCNForm.ArrGL.reset();
      let data: any;
      let data2: any;
      let dbank: any;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/GetRequest/" + sReqID + "").toPromise().then(Data => data = Data)
      _thisCN.ArrRequestCN = data;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/GetTransactionHistory/" + sReqID + "").toPromise().then(Data => data2 = Data)
      _thisCN.ArrTransactionHistory = data2;
      if (this.paytoCNForm.value.ntype == "60") {
        await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/" + _thisCN.ArrRequestCN[0].sVendorCode).toPromise().then(res => {
          if (res) {
            this.DataBankBranch = res;
          }
          else {
            this.DataBankBranch = [];
          }
        })
        if (_thisCN.ArrRequestCN[0].sValue == "Y") {
          this.DataBankBranch.push({ Show: "N/A", BANK_KEY: "N/A", NAME_OF_BANK: "N/A" })
        }
        if (this.DataBankBranch.length > 0) {
          if (_thisCN.ArrRequestCN[0].sValue == "Y" && _thisCN.ArrRequestCN[0].sBankKey === "N/A") {
            this.DataBankBranch2 = [{ Show: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
          }
          else if (_thisCN.ArrRequestCN[0].sBankKey != null && _thisCN.ArrRequestCN[0].sBankKey != "") {
            await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/VENDOR_CODE/" + _thisCN.ArrRequestCN[0].sVendorCode + "/BANK/" + _thisCN.ArrRequestCN[0].sBankKey + "/PARTNER_BANK/ASC").toPromise().then((data: any) => {
              if (data) {
                this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
              }
            })
          }
        }
      }
      else {
        this.IsLoadingBankAll = true;
        this.http.get(this.System.SiteName + "api/Autocomplete/Bank/1/All").toPromise().then(res => {
          if (res) {
            this.DataBankBranch = res;
            this.IsLoadingBankAll = false;
          }
        })
      }
      if (_thisCN.ArrRequestCN != null) {
        _thisCN.Checkinvoice();
        _thisCN.ArrRequestCN.forEach(function (value, i) {
          _thisCN.paytoCNForm.patchValue({
            ntype: value.ntype,
            sComment: value.sComment,
            sCommentSSC: value.sCommentSSC,
          })
          _thisCN.onTypeSelect(value.ntype);
          _thisCN.sComment = value.sComment;
          _thisCN.sCommentSSC = value.sCommentSSC;
          if (value.IsRoService) _thisCN.urgentDay = 8;
        
        })
      }
      let lstArrInvoice = _thisCN.ArrRequestCN != null ? _thisCN.ArrRequestCN.filter(f => f.cActive != 'N') : [];
      if (lstArrInvoice.length > 0) { // เช็คว่า มี invoice ไหม
        if (lstArrInvoice[0].nStatusID == 1 || lstArrInvoice[0].nStatusID == 3 || lstArrInvoice[0].nStatusID == 5 || lstArrInvoice[0].nStatusID == 7 || lstArrInvoice[0].nStatusID == 10) {

          if (lstArrInvoice.length > 0) {
            let chunks = lstArrInvoice[0].dDueDate.split('/');
            this.toDay = lstArrInvoice[0].dRequestDate == null ? this.BusinessDay.SetToday(this.holidays) : new Date(lstArrInvoice[0].dRequestDate);
            let dDuedate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
            let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, dDuedate, this.holidays);
            this.message = (lstArrInvoice[0].nReqUrgentDay < this.urgentDay && this.isSubmit != true && lstArrInvoice[0].nReqUrgentDay != null) ? 'You have ' + lstArrInvoice[0].nReqUrgentDay + ' working days before due date. This is "Urgent" payment' : "";

            this.nReqUrgentDay = lstArrInvoice[0].nReqUrgentDay;
            this.IsReqUrgent = check_date < this.urgentDay ? true : false;
            if ((lstArrInvoice[0].nStatusID == 1 || lstArrInvoice[0].nStatusID == 3 || lstArrInvoice[0].nStatusID == 5 || lstArrInvoice[0].nStatusID == 7 || lstArrInvoice[0].nStatusID == 10) && dDuedate < _thisCN.Settodate) {
              this.maxDate.setDate(this.maxDate.getDate() + 1)
              this.TODAY = this.BusinessDay.SetNextDate(this.maxDate, this.holidays);
              let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, this.TODAY, this.holidays);
              this.olddate = "Old Due Date " + lstArrInvoice[0].dDueDate;
              this.message = (check_date < this.urgentDay && this.isSubmit != true) ? 'You have ' + check_date + ' working days before due date. This is "Urgent" payment' : "";
              this.nReqUrgentDay = check_date;
              this.IsReqUrgent = check_date < this.urgentDay ? true : false;
            }
            await _thisCN.http.get(_thisCN.System.SiteName + "api/_paytovendor/GetRequest/" + lstArrInvoice[0].sCopyReqID + "").toPromise().then((data: any) => {
              if (data != null) {
                let Data = data.filter(f => f.cActive != 'N');
                _thisCN.paytoCNForm.patchValue({
                  sCopyRequest: Data[0].sRequestCode,
                })
              }
            })
            let ddBankKey: any=[];
            let ddBankKey2: any=[];
            if (!_IsNullOrEmpty(lstArrInvoice[0].sBankKey)) {
              //โจ้เปลี่ยน 29/03/2021 ไม่งั้นถ้า .Then แล้วไม่มีข้อมูลระบบตาย
              let GetDT = await _thisCN.http.get(_thisCN.System.SiteName + "api/Autocomplete/MT_BANKKEY/NAME_OF_BANK/BANK_KEY/" + lstArrInvoice[0].sBankKey + "").toPromise();
              if (lstArrInvoice[0].sBankKey === "N/A") {
                GetDT = [{ NAME_OF_BANK: "N/A" }]
              }
              if (GetDT) {
                ddBankKey = GetDT;
              }
              let GetDT2 = await _thisCN.http.get(_thisCN.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/BANK_ACCOUNT/VENDOR_CODE/" + lstArrInvoice[0].sVendorCode + "/BANK_ACCOUNT/" + lstArrInvoice[0].sAccountNo).toPromise();
              if (GetDT2) {
                ddBankKey2 = GetDT2;
              }
            } else {
              ddBankKey = [];
              ddBankKey2 = [];
            }
            await this.onTypeSelect(lstArrInvoice[0].ntype);
            _thisCN.isEditFromhome = true;
            const httpOptions_Amphur = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json'
              }),
              params: new HttpParams()
                .set("sProvCode", lstArrInvoice[0].sProvCode)
            };
            await _thisCN.http.get<any>(_thisCN.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
              if (res) {
                _thisCN._ArrAmphur = res;
              }
            });
            const httpOptions_Tumbon = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json'
              }),
              params: new HttpParams()
                .set("sAmpCode", lstArrInvoice[0].sAmpCode)
            };
            await _thisCN.http.get<any>(_thisCN.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
              if (res) {
                _thisCN._ArrTumbon = res;
              }
            });
            let Country = this._ArrCountry.filter(f => f.sCountryID == lstArrInvoice[0].sCountryID)[0];
            let value = { value: lstArrInvoice[0].sBankName };
            let event = { target: value }
            this.Onbankother(event);
            this.hBranch = lstArrInvoice[0].nOfficeType == 2 ? false : true;
            if (this.hBranch == false) {
              this.paytoCNForm.controls['sBranch'].enable();
              this.paytoCNForm.patchValue({
                sBranch: lstArrInvoice[0].sVendorBranch,
                cbOffice: lstArrInvoice[0].nOfficeType,
              })
              if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
                this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
                  invoice.cbOffice = _thisCN.paytoCNForm.value.cbOffice == 1 ? 1 : lstArrInvoice[0].cbOffice;
                  invoice.nOfficeType = _thisCN.paytoCNForm.value.cbOffice == 1 ? 1 : _thisCN.paytoCNForm.value.cbOffice;
                  invoice.sVendorBranch = lstArrInvoice[0].sVendorBranch;
                })
              }
            } else {
              this.paytoCNForm.controls['sBranch'].disable();
              this.paytoCNForm.patchValue({
                sBranch: "",
                cbOffice: lstArrInvoice[0].nOfficeType,
              })
              if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
                this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
                  invoice.cbOffice = _thisCN.paytoCNForm.value.cbOffice == 1 ? 1 : lstArrInvoice[0].cbOffice;
                  invoice.nOfficeType = _thisCN.paytoCNForm.value.cbOffice == 1 ? 1 : _thisCN.paytoCNForm.value.cbOffice;
                  invoice.sVendorBranch = "";
                })
              }
            }
            _thisCN.ArrRequestCN.forEach(function (value, i) {
              if (value.sPaymentType == "C") {
                _thisCN.paytoCNForm.controls['ddBank'].disable();
                _thisCN.paytoCNForm.patchValue({ sBankAccountName: "" });
              } else {
                _thisCN.messagebank = "Please include passbook and ID Card together with original set of document";
              }
              _thisCN.Currencys = value.sCurrency;
              _thisCN.chackbank(value.sPaymentType);
              _thisCN.IsVendorOneTime = (value.ntype == 61 ? true : false);
              _thisCN.isDraft = (value.nStatusID == 1 || value.nStatusID == 3 || value.nStatusID == 5 || value.nStatusID == 7 || value.nStatusID == 10 ? true : false);
              _thisCN.isSubmit = (value.nStatusID == 2 ? true : false);
              _thisCN.isNew = true;
              _thisCN.isPrint = true;
              _thisCN.isThai = true;
              value.IsDelete = value.cActive == 'N' ? true : false;
              _thisCN.paytoCNForm.patchValue({
                cbOffice: isNullOrUndefined(value.nOfficeType) == true ? 1 : value.nOfficeType,
                nCopyRequest: value.sCopyReqID,
                nVendorCode: value.sVendorCode,
                sVendorName: value.sVendorName,
                sTAXID: value.sTAXID,
                sBranch: value.sVendorBranch,
                sAddress: value.sVendorAddress,
                sCountryID: value.sCountryID,
                txtCountryID: isNullOrUndefined(Country) == true ? "" : Country.sCountryName,
                sProvCode: value.sProvCode,
                sProvName: value.sProvName,
                ddApprover2: value.sUserApprove2,
                sApprove1: value.nApprove1 == null ? null : value.nApprove1,
                sApprove2: value.nApprove2 == null ? null : value.nApprove2,
                cSkipApprove1: value.cSkipApprove1 == "Y" ? true : false,
                GtotalAmountExcluded: _ParseFloatToZero(value.nGrandTotalAmt),
                GtotalVAT: _ParseFloatToZero(value.nGrandTotalAmtVat),
                GtotalWithholdingTax: _ParseFloatToZero(value.nGrandTotalWithholdingTax),
                GtotalAmountOfInvoice: _ParseFloatToZero(value.nGrandTotalAmtInvoice),
                sAmpCode: value.sAmpCode,
                sAmpName: value.sAmpName,
                sTumbonCode: value.sTumbonCode,
                sTumbonName: value.sTumbonName,
                ddCurrency: value.sCurrency,
                sPhoneNumber: value.sPhoneNumber,
                sFaxNumber: value.sFaxNumber,
                sVendorEmail: value.sVendorEmail,
                sBankAccountName: value.sPaymentType == "C" ? "" : value.sAccountName,
                sPostCode: value.sPostCode,
                sInvoiceRef: value.sInvoiceRef,
                sYearInvoiceRef: value.sYearInvoiceRef,
                cbChequeType: value.sPaymentType,
                ddBank: value.sPaymentType == "C" ? "" : value.sBankName,
                nBankAccountNo: value.sAccountNo,
                ddBankKey: (ddBankKey.length > 0) ? ddBankKey[0].NAME_OF_BANK : _thisCN.ArrRequestCN[0].sValue == "Y" && _thisCN.ArrRequestCN[0].sBankKey == "N/A" ? "N/A" : "",
                ddBankKey2: _thisCN.ArrRequestCN[0].sValue == "Y" && _thisCN.ArrRequestCN[0].sAccountNo == "N/A" && ddBankKey.length > 0 ? "N/A" : _thisCN.ArrRequestCN[0].sAccountNo,
                nBankKey: (ddBankKey.length > 0) ? value.sBankKey : null,
                sRequestID: value.sRequestID,
                BankOther: value.sBankOther,
                ddApprover1: value.sUserApprove1,
                nContactID: value.nContactID + "",
                sName: value.sName,
                sEmail: value.sEmail,
                sUnit: value.sUnit,
                sTel: value.sTel,
                ntype: value.ntype,
                dDueDate: new Date(_thisCN.convertTodate(value.dDueDate)),
                sComment: value.sComment,
                sCommentSSC: value.sCommentSSC,
              })
              _thisCN.sComment = value.sComment;
              _thisCN.sCommentSSC = value.sCommentSSC;
              if (value.IsRoService) _thisCN.urgentDay = 8;

              if (value.cSkipApprove1 == "Y") {
                _thisCN.paytoCNForm.get('ddApprover1').disable()
              } else {
                _thisCN.paytoCNForm.get('ddApprover1').enable();
              }
            })
           
          }
          this.ArrMaster = [];
          this.ArrMaster.push(this.ArrIO);
          this.ArrGL.clear()
          this._paytoCNForm.ArrGL.reset();
          _thisCN.ArrGL.push(new FormGroup({
            sAmountExcludedVAT: new FormControl('', Validators.required),
            sInvoiceNo: new FormControl(''),
            sGL: new FormControl('', Validators.required),
            IsDelete: new FormControl(''),
            sIO: new FormControl('', Validators.required),
            nline: new FormControl(''),
            sCostCenter: new FormControl('', Validators.required),
            sText: new FormControl('', Validators.required),
          }))
          _thisCN.checkUseIo();
          _thisCN.checkUseGL();
          _thisCN.System.UnBlockUI();
        }
      } else {
        this.ArrMaster = [];
        this.ArrMaster.push(this.ArrIO);
        this.ArrGL.clear()
        this._paytoCNForm.ArrGL.reset();
        _thisCN.ArrGL.push(new FormGroup({
          sIO: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          IsDelete: new FormControl(''),
          nline: new FormControl,
          sInvoiceNo: new FormControl(''),
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
        }))
        _thisCN.isNew = true;
        _thisCN.ArrRequestCN = [];
        this.checkUseIo();
        this.checkUseGL();
        let data: any;
        let dbank: any;
        this.Currencys = "THB";
        
        _thisCN.paytoCNForm.patchValue({
          GtotalVAT: 0,
          GtotalAmountExcluded: 0,
          GtotalAmountOfInvoice: 0,
          GtotalWithholdingTax: 0,
        });
        await this.http.get(this.System.SiteName + "api/_Paytovendor/GetRequestNoItem/" + sReqID + "").toPromise().then(Data => data = Data)
        if (data != null) {
          this.onTypeSelect(data[0].ntype);
          let chunks = data[0].dDueDate.split('/');
          this.toDay = data[0].dRequestDate == null ? this.BusinessDay.SetToday(this.holidays) : new Date(data[0].dRequestDate);
          let dDuedate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
          let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, dDuedate, this.holidays);
          this.nReqUrgentDay = data[0].nReqUrgentDay;
          this.IsReqUrgent = check_date < this.urgentDay ? true : false;
          this.message = (data[0].nReqUrgentDay < this.urgentDay && this.isSubmit != true && data[0].nReqUrgentDay != null) ? 'You have ' + data[0].nReqUrgentDay + ' working days before due date. This is "Urgent" payment' : "";
          if ((data[0].nStatusID == 1 || data[0].nStatusID == 3 || data[0].nStatusID == 5 || data[0].nStatusID == 7 || data[0].nStatusID == 10) && dDuedate < _thisCN.Settodate) {
            this.maxDate.setDate(this.maxDate.getDate() + 1)
            this.TODAY = this.BusinessDay.SetNextDate(this.maxDate, this.holidays);
            let check_date = this.BusinessDay.setDueDatebyDate(this.Settodate, this.TODAY, this.holidays);
            this.olddate = "Old Due Date " + data[0].dDueDate;
            this.message = (check_date < this.urgentDay && this.isSubmit != true) ? 'You have ' + check_date + ' working days before due date. This is "Urgent" payment' : "";
            this.nReqUrgentDay = check_date;
            this.IsReqUrgent = check_date < this.urgentDay ? true : false;
          }
          if (data[0].sPaymentType == "T") {
            _thisCN.messagebank = "Please include passbook and ID Card together with original set of document";
          } else {
            _thisCN.messagebank = "";
          }
          let ddBankKey: any;
          let ddBankKey2: any;
          if (!_IsNullOrEmpty(data[0].sBankKey)) {
            //โจ้เปลี่ยน 29/03/2021 ไม่งั้นถ้า .Then แล้วไม่มีข้อมูลระบบตาย
            let GetDT = await _thisCN.http.get(_thisCN.System.SiteName + "api/Autocomplete/MT_BANKKEY/NAME_OF_BANK/BANK_KEY/" + data[0].sBankKey + "").toPromise();
            if (GetDT) {
              ddBankKey = GetDT;
            }
            let GetDT2 = await _thisCN.http.get(_thisCN.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/BANK_ACCOUNT/VENDOR_CODE/" + lstArrInvoice[0].sVendorCode + "/BANK_ACCOUNT/" + lstArrInvoice[0].sAccountNo).toPromise();
            if (GetDT2) {
              ddBankKey2 = GetDT2;
            }
          } else {
            ddBankKey = null;
            ddBankKey2 = null;
          }
          if (data[0].cSkipApprove1 == "Y") {
            _thisCN.paytoCNForm.get('ddApprover1').disable()
          } else {
            _thisCN.paytoCNForm.get('ddApprover1').enable();
          }
          _thisCN.paytoCNForm.patchValue({
            sTel: data[0].sTel,
            ntype: data[0].ntype,
            nContactID: data[0].nContactID + "",
            sName: data[0].sName,
            sEmail: data[0].sEmail,
            sUnit: data[0].sUnit,
            ddApprover1: data[0].sUserApprove1,
            ddApprover2: data[0].sUserApprove2,
            sApprove1: data[0].nApprove1 == null ? null : data[0].nApprove1,
            sApprove2: data[0].nApprove2 == null ? null : data[0].nApprove2,
            cSkipApprove1: data[0].cSkipApprove1 == "Y" ? true : false,
            sBankAccountName: data[0].sPaymentType == "C" ? "" : data[0].sAccountName,
            ddBank: data[0].sPaymentType == "C" ? "" : data[0].sBankName,
            nBankAccountNo: data[0].sAccountNo,
            ddBankKey: (ddBankKey != null) ? ddBankKey.NAME_OF_BANK : data[0].sValue == "Y" && data[0].sBankKey == "N/A" ? "N/A" : "",
            ddBankKey2: (ddBankKey2 != null) ? ddBankKey2.BANK_ACCOUNT : data[0].sValue == "Y" && data[0].sAccountNo == "N/A" ? "N/A" : "",
            nBankKey: data[0].sBankKey,
            sRequestID: data[0].sRequestID,
            BankOther: data[0].sBankOther,
            sInvoiceRef: data[0].sInvoiceRef,
            sYearInvoiceRef: data[0].sYearInvoiceRef,
            cbChequeType: data[0].sPaymentType,
            dDueDate: dDuedate,
          });

          //#region setfile
          let file: any;
          await this.http.get(this.System.SiteName + "api/_Paytovendor/Getfile/" + sReqID + "").toPromise().then(Data => file = Data);
          if (file) {
            let arrdata = [];
            if (file.length != 0) {
              file.forEach(f => arrdata.push({
                sFileName: f.sFileName,
                sSize: +f.sFileSize,
                nID: f.nFileOrder,
                sPath: f.sPathFile,
                sSystemFileName: f.sSystemFileName,
              }))
              SetData('dvFile', arrdata)
            }
          }
          //#endregion

        }

        this.System.UnBlockUI();
      }
    } else {
      this.messagebank = "Please include passbook and ID Card together with original set of document";
      this.Currencys = "THB";
      _thisCN.paytoCNForm.patchValue({
        GtotalAmountExcluded: 0,
        GtotalWithholdingTax: 0,
        GtotalAmountOfInvoice: 0,
        GtotalVAT: 0,
      });
      if (!this.isNewRequest) {
        let data: any;
        await _thisCN.http.get(_thisCN.System.SiteName + "api/ROService/GetRequest/" + sReqID + "").toPromise().then(Data => data = Data)
        if(data != null){
          _thisCN.paytoCNForm.patchValue({
            sRequestID: data[0].sRequestID,
            ntype: data[0].nReqType.toString(),
            sComment: data[0].sComment,
            sCommentSSC: `Expected Complete Date : ${data[0].dExpectedCompleteDate}${data[0].sRemarkSSC ? `\n${data[0].sRemarkSSC}` : ''}`,
          });
          _thisCN.sComment = data[0].sComment;
          _thisCN.sCommentSSC = data[0].sRemarkSSC;
          _thisCN.onTypeSelect(data[0].nReqType.toString());
          _thisCN.onUserSelect(data[0].sFullName);
        }
      }
   
      this.System.UnBlockUI();
    }
    if (!this.isNewRequest) {
      let file: any;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/Getfile/" + sReqID + "").toPromise().then(Data => file = Data);
      if (file) {
        let arrdata = [];
        if (file.length != 0) {
          file.forEach(f => arrdata.push({
            nID: f.nFileOrder,
            sPath: f.sPathFile,
            sSystemFileName: f.sSystemFileName,
            sFileName: f.sFileName,
            sSize: +f.sFileSize,
          }))
          SetData('dvFile', arrdata)
        }
      }
    }
   

    //Check Permission
    let ObjData = {
      sRequestID: sReqID,
      nMenuID: 45
    }
    let isio = await this.System.GetCompanyUSEIO(ObjData);
    if (isio != null) {
      _thisCN.isUseIo = isio;
      _thisCN.IsNotFill_IO = isio;
      _thisCN.checkUseIo();
    }
    let isGL = await this.System.GetCompanyUSEGL(ObjData);
    if (isGL != null) {
      _thisCN.isUseGL = isGL;
      _thisCN.IsNotFill_GL = isGL;
      _thisCN.checkUseGL();
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (!this.ResultPermission) {
      this.paytoCNForm.disable();
      this.paytoCNForm.get('GtotalAmountExcluded').enable();
      this.paytoCNForm.get('GtotalAmountOfInvoice').enable();
      this.paytoCNForm.get('GtotalWithholdingTax').enable();
      this.paytoCNForm.get('sCompName').enable();
      this.paytoCNForm.get('GtotalVAT').enable();

    }

  }

  //*****************************************
  OnBlurGCI(event, _inx, _sType) {
    let FromArray = this.paytoCNForm.get('ArrGL') as FormArray;
    let Pass: boolean = true;
    try {
      switch (_sType) {
        case "G":
          let stG = this.ArrGL.at(_inx).get('sGL').value;
          let ischeckG = this.sArrGL.filter(f => f.GL_ACCOUNT_NO == stG || f.name == stG || f.SHORT_TEXT == stG)[0];
          if (isNullOrUndefined(ischeckG)) {
            Pass = false;
          }
          break;
        case "C":
          let stC = this.ArrGL.at(_inx).get('sCostCenter').value;
          let ischeckC = this.ArrCostCenter.filter(f => f.COST_CENTER == stC || f.name == stC || f.DESCRIPTION == stC)[0];
          if (isNullOrUndefined(ischeckC)) {
            Pass = false;
          }
          break;
        case "I":
          let stI = this.ArrGL.at(_inx).get('sIO').value;
          let ischeckI = this.ArrMaster[_inx].filter(f => f.ORDER_NUMBER == stI || f.name == stI || f.DESCRIPTION == stI)[0];
          if (isNullOrUndefined(ischeckI)) {
            Pass = false;
          }
          break;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      this.OnSelectGCI(event, _inx, _sType)
    }
    else if (!Pass) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
      }
    }
  }
  OnSelectGCI(event: TypeaheadMatch, _inx, _sType) {

    let _thisCN = this;
    let FromArray = this.paytoCNForm.get('ArrGL') as FormArray;
    let sGL = FromArray.at(_inx).get("sGL").value;
    let sCostCenter = FromArray.at(_inx).get("sCostCenter").value;
    let sIO = (FromArray.at(_inx).get("sIO").value != null) ? FromArray.at(_inx).get("sIO").value : ""; //แก้ไขกรณี company ไม่มี IO

    let SP_GL = sGL.split('-');
    let SP_CCTR = sCostCenter.split('-');
    let SP_IO = sIO.split('-');

    let SE_GL = SP_GL.length > 1 ? (SP_GL[0] + "").trim() : sGL;
    let SE_CCTR = SP_CCTR.length > 1 ? (SP_CCTR[0] + "").trim() : sCostCenter;
    let SE_IO = SP_IO.length > 1 ? (SP_IO[0] + "").trim() : sIO;

    let _CHK = this.OnChange_CheckDuplicateGCI(SE_GL, SE_CCTR, SE_IO, _inx);
    if (false) {
    //if (!_CHK.IsPass) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
      }
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, _CHK.Msg, function () { Swal.close() });
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: event.item.GL_ACCOUNT_NO });
          break;
        case "C":
          this.ArrMaster[_inx] = this.ArrIO;
          FromArray.at(_inx).patchValue({ sCostCenter: event.item.COST_CENTER });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: event.item.ORDER_NUMBER });
          break;
      }
    }
  }

  AddGL() {
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl('', Validators.required),
      sIO: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl('')
    }));
    this.checkUseIo()
    this.checkUseGL()
  }
  DeleteGL(sInvoiceNo, row) {

    let _thisCN = this;
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
      _thisCN.ArrGL.at(row).patchValue({ IsDelete: true });
      let isnull = !isNullOrUndefined(sInvoiceNo) ? sInvoiceNo : "";
      if (isnull == "") {
        _thisCN.ArrGL.removeAt(row);
      } else {
        let data = _thisCN.ArrRequestCN.filter(f => f.sInvoiceNo == sInvoiceNo)[row];
        if (data) {
          data.IsDelete = true;
        }
        let FieldGLValid: string[] = ['sGL', 'sCostCenter', 'sIO', 'sAmountExcludedVAT', 'sText'];
        for (let i = 0; i < FieldGLValid.length; i++) {
          _thisCN.ArrGL.at(row).get(FieldGLValid[i]).clearValidators();
          _thisCN.ArrGL.at(row).get(FieldGLValid[i]).setValidators([]);
          _thisCN.ArrGL.at(row).get(FieldGLValid[i]).updateValueAndValidity();
        }
      }
      // _thisCN.Checkinvoice();
    }, function () { });
  }
  OnChange_CheckDuplicateGCI(sGL, sCostCenter, sIO, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Array Invoice
    for (var i = 0; i < this.ArrGL.length; i++) {
      if (i != _inx) {//ตรวจสอบ Index ว่าต้องไม่เป็น Index กับตัวที่ Select
        let Isdelete = this.ArrGL.value[i].IsDelete;
        let _sGL = this.ArrGL.value[i].sGL;
        let _sCostCenter = this.ArrGL.value[i].sCostCenter;
        let _sIO = this.ArrGL.value[i].sIO;
        if (!Isdelete) {
          if (this.IsNotFill_IO && this.IsNotFill_GL) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO && IsNotFill_GL คือระบบไม่ต้องกรอก GL
            if (!_IsNullOrEmpty(sCostCenter)) {//เช็คแค่ CostCenter
              if (sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else if (this.IsNotFill_IO) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO
            if (!_IsNullOrEmpty(sGL) && !_IsNullOrEmpty(sCostCenter)) {//เช็คแค่ GL,CostCenter
              if (sGL == _sGL && sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else if (this.IsNotFill_GL) {//IsNotFill_GL คือระบบไม่ต้องกรอก GL
            if (!_IsNullOrEmpty(sIO) && !_IsNullOrEmpty(sCostCenter)) {//เช็คแค่ IO,CostCenter
              if (sIO == _sIO && sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else {
            if (sGL == _sGL && sCostCenter == _sCostCenter && sIO == _sIO) { //เช็คแค่ GL,CostCenter , IO
              Result.IsPass = false;
              Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
              return Result;
            }
          }
        }
      }
    }

    return Result;
  }
  CheckDuplicateGCI(sGL, sCostCenter, sIO, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Database
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sGL", sGL)
        .set("sCostCenter", sCostCenter)
        .set("sIO", sIO)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/CheckDuplicateGCI", httpOptions).subscribe(res => {
      if (res) {
        if (res.length > 0) {
          Result.IsPass = false;
          Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
        }
        else {
          Result.IsPass = true;
        }
      }
      else {
        Result.IsPass = true;
      }
    });
    return Result;
  }
  hidBranch() {

    let _thisCN = this;
    this.hBranch = this.paytoCNForm.value.cbOffice == 2 ? false : true;
    if (this.hBranch == false) {
      var code = this.paytoCNForm.get('sBranch').value;
      if (code === '') code = '00000'
      this.paytoCNForm.controls['sBranch'].enable();
      this.paytoCNForm.patchValue({ sBranch: code })
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.cbOffice = _thisCN.paytoCNForm.value.cbOffice == 1 ? 1 : _thisCN.paytoCNForm.value.cbOffice;
          invoice.nOfficeType = _thisCN.paytoCNForm.value.cbOffice == 1 ? 1 : _thisCN.paytoCNForm.value.cbOffice;
          invoice.sVendorBranch = code;
        })
      }
    } else {
      this.paytoCNForm.controls['sBranch'].disable();
      this.paytoCNForm.patchValue({ sBranch: "" })
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.cbOffice = _thisCN.paytoCNForm.value.cbOffice == 1 ? 1 : _thisCN.paytoCNForm.value.cbOffice;
          invoice.nOfficeType = _thisCN.paytoCNForm.value.cbOffice == 1 ? 1 : _thisCN.paytoCNForm.value.cbOffice;
          invoice.sVendorBranch = "";
        })
      }
    }
  }
  hidBankDetail() {
    let _thisCN = this;
    this.hBank = this.paytoCNForm.value.cbChequeType == 'C' ? true : false;
    if (this.hBank == false) {
      this.paytoCNForm.controls.nBankAccountNo.clearValidators();
      this.paytoCNForm.controls['sBankAccountName'].enable();
      // this.paytoCNForm.controls['nBankAccountNo'].enable();
      this.paytoCNForm.controls['ddBankKey'].enable();
      // this.paytoCNForm.controls['ddBankKey2'].enable();
      this.paytoCNForm.controls['ddBank'].enable();
      this.paytoCNForm.controls.nBankAccountNo.markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls.nBankAccountNo.setValidators([Validators.required]);
      this.paytoCNForm.controls.ddBankKey2.clearValidators();
      this.paytoCNForm.controls.ddBank.setValidators([Validators.required]);
      this.paytoCNForm.controls.ddBank.updateValueAndValidity();
      this.paytoCNForm.controls['nBankKey'].enable();
      this.paytoCNForm.controls.nBankAccountNo.updateValueAndValidity();
      this.paytoCNForm.controls.ddBankKey.clearValidators();
      this.paytoCNForm.controls.ddBankKey.markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls.ddBankKey.setValidators([Validators.required]);
      this.paytoCNForm.controls.ddBankKey.updateValueAndValidity();
      this.paytoCNForm.controls.ddBankKey2.markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls.ddBankKey2.setValidators([Validators.required]);
      this.paytoCNForm.controls.ddBankKey2.updateValueAndValidity();
      this.paytoCNForm.controls.ddBank.clearValidators();
      this.paytoCNForm.controls.ddBank.markAsUntouched({ onlySelf: true });
      this.paytoCNForm.patchValue({ sBankAccountName: _thisCN.paytoCNForm.get('sVendorName').value })
      this.paytoCNForm.patchValue({ cbChequeType: 'T' });
      _thisCN.messagebank = "Please include passbook and ID Card together with original set of document";

    } else {
      let bankvalidate = ["nBankAccountNo", "ddBank", "ddBankKey", "ddBankKey2"];

      bankvalidate.forEach(function (form) {
        _thisCN.paytoCNForm.controls[form].clearValidators();
        _thisCN.paytoCNForm.controls[form].markAsUntouched({ onlySelf: true });
        _thisCN.paytoCNForm.controls[form].setValidators([]);
        _thisCN.paytoCNForm.controls[form].updateValueAndValidity();
      })
      this.paytoCNForm.controls['ddBank'].disable();
      this.paytoCNForm.controls["BankOther"].updateValueAndValidity();
      this.paytoCNForm.controls["BankOther"].clearValidators();
      this.paytoCNForm.controls["BankOther"].markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls["BankOther"].setValidators([]);
      this.paytoCNForm.controls["BankOther"].setErrors(null);
      this.paytoCNForm.controls["BankOther"].disable()
      this.paytoCNForm.controls['sBankAccountName'].disable();
      this.paytoCNForm.controls['nBankAccountNo'].disable();
      this.paytoCNForm.controls['nBankKey'].disable();
      this.paytoCNForm.patchValue({ ddBank: "", });
      this.DataBankBranch2 = [];
      this.paytoCNForm.controls['ddBankKey'].disable();
      this.paytoCNForm.controls['ddBankKey2'].disable();

      this.paytoCNForm.patchValue({
        nBankKey: "",
        sBankAccountName: "",
        BankOther: "",
        nBankAccountNo: "",
        ddBankKey: "",
        ddBankKey2: "",
      })
      this.paytoCNForm.patchValue({ cbChequeType: 'C' });
      _thisCN.messagebank = "";
    }
  }
  OnSkipApprove1() {
    let _thisCN = this;
    if (_thisCN.paytoCNForm.value["cSkipApprove1"]) {
      _thisCN.paytoCNForm.patchValue({ sApprove1: null });
      _thisCN.paytoCNForm.get('ddApprover1').reset();
      _thisCN.paytoCNForm.get('ddApprover1').disable();
    }
    else {
      let name1 = _thisCN.DataApprover.filter(f => f.nUserID == _thisCN.GetApprover.name1ID)[0];
      let nUserId = _thisCN.DataApprover.filter(f => f.nUserID == _thisCN.GetApprover.name1ID)[0];
      this.paytoCNForm.patchValue({
        ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
        sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
      })
      this.paytoCNForm.get('ddApprover1').enable();
    }
  }
  Export() {
    const link = document.createElement('a');
    link.target = '_blank'
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.sReqID + "")
        .set("nContactID", this.paytoCNForm.get("nContactID").value),

    };
    link.href = this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params
    link.setAttribute('visibility', 'hidden');
    link.click();
  }
  Back() {
    this.router.navigate(['/home'])
  }
  chackbank(PaymentType) {
    let _thisCN = this;
    this.hBank = PaymentType == 'C' ? true : false;
    if (this.hBank == false) {
      this.paytoCNForm.controls.ddBank.setValidators([Validators.required]);
      this.paytoCNForm.controls.ddBank.updateValueAndValidity();
      this.paytoCNForm.controls['sBankAccountName'].enable();
      this.paytoCNForm.controls['nBankAccountNo'].enable();
      this.paytoCNForm.controls['nBankKey'].enable();
      this.paytoCNForm.controls.nBankAccountNo.clearValidators();
      this.paytoCNForm.controls.ddBankKey.setValidators([Validators.required]);
      this.paytoCNForm.controls.ddBankKey.updateValueAndValidity();
      this.paytoCNForm.controls.ddBankKey2.clearValidators();
      this.paytoCNForm.controls.ddBankKey2.markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls['ddBankKey2'].enable();
      this.paytoCNForm.controls['ddBank'].enable();
      this.paytoCNForm.controls.ddBankKey2.setValidators([Validators.required]);
      this.paytoCNForm.controls.ddBankKey2.updateValueAndValidity();
      this.paytoCNForm.controls.ddBank.clearValidators();
      this.paytoCNForm.controls.ddBank.markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls.nBankAccountNo.markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls.nBankAccountNo.setValidators([Validators.required]);
      this.paytoCNForm.controls.nBankAccountNo.updateValueAndValidity();
      this.paytoCNForm.controls.ddBankKey.clearValidators();
      this.paytoCNForm.controls.ddBankKey.markAsUntouched({ onlySelf: true });


    } else {
      let bankvalidate = ["nBankAccountNo", "ddBank", "ddBankKey", "ddBankKey2"];
      bankvalidate.forEach(function (form) {
        _thisCN.paytoCNForm.controls[form].clearValidators();
        _thisCN.paytoCNForm.controls[form].markAsUntouched({ onlySelf: true });
        _thisCN.paytoCNForm.controls[form].setValidators([]);
        _thisCN.paytoCNForm.controls[form].updateValueAndValidity();
      })
      this.paytoCNForm.controls['sBankAccountName'].disable();
      this.paytoCNForm.controls["BankOther"].clearValidators();
      this.paytoCNForm.controls["BankOther"].markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls["BankOther"].updateValueAndValidity();
      this.paytoCNForm.controls["BankOther"].disable();
      this.paytoCNForm.controls['ddBank'].disable();
      this.paytoCNForm.controls["BankOther"].setValidators([]);
      this.paytoCNForm.controls["BankOther"].setErrors(null);
      this.paytoCNForm.controls['ddBankKey2'].disable();
      this.paytoCNForm.controls['nBankAccountNo'].disable();
      this.paytoCNForm.controls['nBankKey'].disable();
      this.DataBankBranch2 = [];

    }
  }
  //#region "SetFormCN"
  SetFormCN() {
    let ua = this.System.GetUserStorage()
    this.paytoCNForm = this.formBuilder.group({

      sCompName: [ua.sCompName],
      sBusinessArea: [null],

      ntype: ["60"],

      sAddress: [null, Validators.required],
      txtCountryID: [null],
      ntype2: ["60"],
      dDueDate: [null, Validators.required],
      sCopyRequest: [null],
      nCopyRequest: [null],
      nVendorCode: [null, Validators.required],
      sTAXID: [null, Validators.required],
      sVendorName: [null, Validators.required],
      cbOffice: [1],
      sBranch: [null],
      sProvCode: [null],
      sProvName: [null],
      sAmpCode: [null],
      sAmpName: [null],
      sCountryID: "",
      sRequestID: [null],
      sRequestBy: [ua.nUserID],
      nContactID: [ua.nUserID],
      sName: [ua.sFullName, Validators.required],
      sTumbonName: [null],
      sPostCode: [null],
      sPhoneNumber: [null],
      sFaxNumber: [null],
      sVendorEmail: [null],
      sAddressOneTime: [null],

      sInvoiceNo: [null, Validators.required],
      dInvoiceDate: [new Date(), Validators.required],
      nTotalAmount: [null],
      ddCurrency: ["THB"],
      sEmail: [ua.sEmail, Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$")],
      sUnit: [ua.sUnitName],
      sTel: [ua.sTel],
      dToday: [this.dToday],
      sCompCode: [ua.sCompCode],
      nVat: [null,],
      ddVatType: ["-1"],
      nVatAmount: [null, Validators.required],
      nTotalAmountInvoice: [null],
      nTotalAmountVat: [null, Validators.required],
      ddlWithholdingTax: " ",
      ddlWithholdingTax2: " ",
      nWHTRate: [null],
      nWHTRate2: [null],
      nWHTOther: [null],
      nWHTOther2: [null],
      nWHTVal: [null],
      _nWHTVal: [null],
      nWHTVal2: [null],
      _nWHTVal2: [null],
      nWHTBase: [null],
      nWHTBase2: [null],
      sTumbonCode: [null],
      ddBankKey2: [null, Validators.required],
      GtotalAmountOfInvoice: [null],
      sComment: [null],
      sCommentSSC: [null],
      ddApprover1: [null, Validators.required],
      sApprove1: [null],
      sApprove2: [null],
      ddApprover2: [null, Validators.required],
      cSkipApprove1: [null],
      cbChequeType: ['T'],
      ddBank: ["", Validators.required],
      BankOther: ua.sCompCode == 396 ? ["", Validators.required] : [null],
      sBankAccountName: [null],

      ArrGL: new FormArray([
        new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl('', Validators.required),
          sIO: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(false),
          sInvoiceNo: new FormControl(''),
          nline: new FormControl('')
        })
      ]),
      GtotalAmountExcluded: [null],
      GtotalWithholdingTax: [null],
      GtotalVAT: [null],
      sInvoiceRef: ["", [Validators.required, Validators.minLength(10)]],
      sYearInvoiceRef: ["", [Validators.required, Validators.minLength(4)]],
      nBankAccountNo: [null, Validators.required],
      nBankKey: [null],
      ddBankKey: [null, Validators.required],

    });
  }
  //#endregion


  getReqID() {
    let comcodeCN = this.nComcode;
    let widthCN = comcodeCN.toString().length;
    if (widthCN > 0) {
      comcodeCN = new Array(widthCN == 3 ? 0 : 3).join('0') + comcodeCN;
    }
    let dTodayCN = this.datepipe.transform(this.today, 'yyMMdd')
    let typeCN = this.paytoCNForm.value.ntype;
    let ReqIDCN: string = comcodeCN + dTodayCN + typeCN;
    return ReqIDCN;
  }
  numberOnly(event): boolean {
    const charCode = event.key;
    var regExp1 = new RegExp('[A-Za-z]', 'g');
    if (regExp1.test(charCode)) {
      return false;
    } else {
      return true;
    }
  }
  //#region Validate
  isFieldValid(_Field: string) {
    if (this.paytoCNForm) {
      return !this.paytoCNForm.get(_Field).valid && this.paytoCNForm.get(_Field).touched;
    }
    else {
      return false;
    }
  }
  displayFieldCss(_Field: string) {
    return {
      'has-error': this.isFieldValid(_Field),
      'has-feedback': this.isFieldValid(_Field)
    };
  }
  isFieldValidTbGl(_Field: string, _inx) {
    let FromArray = this.paytoCNForm.get('ArrGL') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssTbGl(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidTbGl(_Field, _inx),
      'has-feedback': this.isFieldValidTbGl(_Field, _inx)
    };
  }
  //#endregion
  async checkDupinBase(Invoice, InvoiceDate) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let chunks = InvoiceDate.split('/');
    let dInvoiceDate = (chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
    let data = JSON.stringify({ Invoice: Invoice, InvoiceDate: dInvoiceDate, sCompCode: this.nComcode })
    return await this.http.post(this.System.SiteName + "api/_Paytovendor/CheckDupinBase", data, { headers, responseType: 'text' }).toPromise().then(s => s);
  }

  async EditcheckDupinBase(Invoice, InvoiceDate, sReqid) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let chunks = InvoiceDate.split('/');
    let dInvoiceDate = (chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
    let data = JSON.stringify({ Invoice: Invoice, InvoiceDate: dInvoiceDate, sReqid: sReqid, sCompCode: this.nComcode })
    return await this.http.post(this.System.SiteName + "api/_Paytovendor/EditCheckDupinBase", data, { headers, responseType: 'text' }).toPromise().then(s => s);
  }
  CalGrand() {
    let _thisCN = this;
    this.Currencys = this.paytoCNForm.get('ddCurrency').value;
    let arrGtotalAmountOfInvoice = _thisCN.ArrRequestCN.filter(f => f.IsDelete == false && f.cActive != 'N').map(m => _thisCN.Check2Digit(m.sAmount));
    let GtotalAmountExcluded = arrGtotalAmountOfInvoice.reduce((acc, cur) => (acc + cur), 0).toFixed(2)
    let arrinvoiceVat = [];
    let arrinvoiceWHT = [];
    let GroupByinvoice = [];
    _thisCN.ArrRequestCN.filter(f => f.IsDelete == false && f.cActive != 'N').forEach(function (value, i) {
      let obj = {
        invoice: value.sInvoiceNo,
        InvoiceDate: value.dInvoiceDate
      }
      let ckhave = GroupByinvoice.filter(f => f.invoice == obj.invoice && f.InvoiceDate == obj.InvoiceDate);
      if (ckhave.length == 0) {
        GroupByinvoice.push(obj)
      }

    });
    GroupByinvoice.forEach(function (value, i) {
      let Get_InvoiceVat = _thisCN.ArrRequestCN.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate && f.IsDelete == false && f.cActive != 'N');
      if (Get_InvoiceVat.length > 0) {
        arrinvoiceVat.push(_thisCN.Check2Digit(Get_InvoiceVat[0].nVAT));
        arrinvoiceWHT.push(_thisCN.Check2Digit(Get_InvoiceVat[0].nWHTVal) + _thisCN.Check2Digit(Get_InvoiceVat[0].nWHTVal2));
      }
    })
    let GtotalVAT = _ParseFloatToZero(arrinvoiceVat.reduce((acc, cur) => (acc + cur), 0));
    let GtotalWHT = _ParseFloatToZero(arrinvoiceWHT.reduce((acc, cur) => (acc + cur), 0));
    // let arrGtotalWithholdingTax = _thisCN.ArrRequestCN.filter(f => f.IsDelete == false && f.cActive != 'N').map(m => _ParseFloatToZero(m.nWHTVal));
    // let arrGtotalWithholdingTax2 = _thisCN.ArrRequestCN.filter(f => f.IsDelete == false && f.cActive != 'N').map(m => _ParseFloatToZero(m.nWHTVal2));
    // let GtotalWithholdingTax = _ParseFloatToZero(arrGtotalWithholdingTax.reduce((acc, cur) => (acc + cur), 0))
    // let GtotalWithholdingTax2 = _ParseFloatToZero(arrGtotalWithholdingTax2.reduce((acc, cur) => (acc + cur), 0))
    
    
    let GtotalAmountOfInvoice = _ParseFloatToZero(((Number(GtotalVAT) + _ParseFloatToZero(GtotalAmountExcluded)) - _ParseFloatToZero(GtotalWHT)).toFixed(2))
    this.paytoCNForm.patchValue({
      GtotalAmountExcluded: (GtotalAmountExcluded),
      GtotalVAT: (GtotalVAT),
      GtotalWithholdingTax: (GtotalWHT == "NaN" ? 0 : GtotalWHT),
      GtotalAmountOfInvoice: (GtotalAmountOfInvoice),
    })

  }
  convertTodate(dDate) {
    let chunks = dDate.split('/');
    return new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
  }
  _ConvertToDecimal(sVal) {
    if(!sVal || sVal === 'NaN') sVal = '0';
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    let Data = this._decimalPipe.transform(NoComma, "1.2-2");
    return Data;
  }
  //NoResult
  TypeNoResults(event: boolean): void {
    this.TypeNoResult = event;
    if (event) {
      this.VendorCodemaxLength = 11;
    } else {
      this.VendorCodemaxLength = 50;
    }
  }
  TypeOnBlur(item) {
    var vendorcode1 = this.paytoCNForm.get('nVendorCode').value;
    var ischeck1 = this.ArrVendor.filter(f => f.VENDOR_CODE == vendorcode1 || f.Vendor == vendorcode1)[0];
    if (this.TypeNoResult == true && this.paytoCNForm.get("ntype").value == "60") {
      this.paytoCNForm.patchValue({ nVendorCode: null });
      this.ClearInvoice();
    } else if (this.TypeNoResult == false && !isNullOrUndefined(ischeck1)) {
      this.onVendorSelect(item);
    } else if (this.TypeNoResult == false && isNullOrUndefined(ischeck1)) {
      this.paytoCNForm.patchValue({ nVendorCode: null });
      this.ClearInvoice();
    }
    if (this.paytoCNForm.get("ntype").value == "61") {
      if (this.ArrRequestCN.filter(f => f.cActive != 'N').length > 0) {
        this.ArrRequestCN.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (item.value != null && !_IsNullOrEmpty(item.value)) {
            invoice.sVendorCode = item.value == null ? "" : item.value;
          } else {
            invoice.sVendorCode = "";
          }
        })
      }
    }
  }
  CopyNoResults(event: boolean): void {
    this.CopyNoResult = event;
  }
  CopyOnBlur(item) {
    let sCopyRequest = this.paytoCNForm.get('sCopyRequest').value;
    let ischeck = this.DataRequest.filter(user => user.sRequestCode == sCopyRequest)[0];
    if (sCopyRequest == "") {
      /*    this.ArrRequestCN = [];
          this.ClearInvoice();
          this.Checkinvoice();*/
    } else if (sCopyRequest != null && this.CopyNoResult == false && !isNullOrUndefined(ischeck)) {
      this.onCopyRequestCodeSelect(item)
    }
    if (this.CopyNoResult == true) {
      this.paytoCNForm.patchValue({
        sCopyRequest: null,
        nCopyRequest: null
      });
      /*      this.ArrRequestCN = [];
            this.ClearInvoice();
            this.Checkinvoice();*/
    } else if (this.CopyNoResult == false && isNullOrUndefined(ischeck)) {
      this.paytoCNForm.patchValue({ sCopyRequest: null, nCopyRequest: null });
    }
  }
  //GL NoResult ----------------------------------------------

  GlNoResults(event: boolean, index): void {
    this.GlNoResult[index] = event;
  }
  GlOnBlur(event, index) {
    if (this.GlNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sGL: null })
    }
  }
  CostCenterNoResults(event: boolean, index): void {
    this.CostCenterNoResult[index] = event;
  }
  CostCenterOnBlur(event, index) {
    if (this.CostCenterNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sCostCenter: null })
    }
  }
  IONoResults(event: boolean, index): void {
    this.IONoResult[index] = event;
  }
  IOOnBlur(event, index) {
    if (this.IONoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sIO: null })
    }
  }
  //-----------------------------------------------


  //Country NoResult ------------------------------------------

  CountryNoResult(event: boolean): void {
    this.isCountryNoResult = event;
  }
  CountryOnBlur(item) {
    if (this.isCountryNoResult == true) {
      this.paytoCNForm.patchValue({ txtCountryID: null });
    } else {
      this.OnCountryselect(item);
    }
  }
  NoResultsAmphor(event: boolean): void {
    this.sAmphorNoResult = event;
  }
  NoResultsTumbon(event: boolean): void {
    this.sTumbonNoResult = event;
  }
  NoResultsSubDistrict(event: boolean): void {
    this.sSubDistrictNoResult = event;
  }

  BankNoResults2(event: boolean): void {
    this.BankNoResult2 = event;
  }
  BankNoResults(event: boolean): void {
    this.BankNoResult = event;
  }


  BankOnBlur(item) {
    let bank = this.paytoCNForm.get('ddBankKey').value;
    let ischeck = this.DataBankBranch.filter(f => f.Show == bank);
    if (ischeck.length == 0) {
      ischeck = this.DataBankBranch.filter(f => f.NAME_OF_BANK == bank);
      if (ischeck.length == 0) {
        ischeck = this.DataBankBranch.filter(f => f.BANK_KEY == bank);
      }
    }

    if (this.BankNoResult == true) {
      this.paytoCNForm.patchValue({ ddBankKey: null, ddBankKey2: null });
      this.paytoCNForm.controls['ddBankKey2'].disable();
    } else if (this.BankNoResult == false && ischeck.length > 0) {
      this.onBankBranchSelect(item);
    } else if (this.BankNoResult == false && ischeck.length == 0) {
      this.paytoCNForm.patchValue({ ddBankKey: null, ddBankKey2: null });
      this.paytoCNForm.controls['ddBankKey'].enable();
      this.paytoCNForm.controls['ddBankKey2'].disable();
    }
  }

  BankOnBlur2(item) {
    let bank = this.paytoCNForm.get('ddBankKey2').value;
    let ischeck = this.DataBankBranch2.filter(f => f.BANK_ACCOUNT == bank);
    if (this.BankNoResult2 == true) {
      this.paytoCNForm.patchValue({ ddBankKey2: null });
    } else if (this.BankNoResult2 == false && ischeck.length > 0) {
      this.onBankBranchSelect2(item);
    } else if (this.BankNoResult2 == false && ischeck.length == 0) {
      this.paytoCNForm.patchValue({ ddBankKey2: null });
    }
  }
  Approver2NoResults(event: boolean): void {
    this.Approve2NoResult = event;
  }
  Approver1NoResults(event: boolean): void {
    this.Approve1NoResult = event;
  }
  //
  Checkinvoice() {
    let _thisCN = this;
    let lstData = this.ArrRequestCN.filter(f => f.cActive != 'N')[0];
    this.ArrInvoicelength = this.ArrRequestCN.filter(f => f.cActive != 'N').length;
    let onetime = ["sVendorName", "sTAXID", "sAddress", "sBranch", "cbOffice", "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode"];
    if (this.ArrRequestCN.filter(f => f.cActive != 'N').length >= 1) {
      if (lstData.ntype == "61" || _thisCN.paytoCNForm.get("ntype").value == "61") {
        onetime.forEach(function (value) {
          _thisCN.paytoCNForm.controls[value].markAsUntouched({ onlySelf: true });
        })
      }
      this.paytoCNForm.controls['ntype'].disable();
      this.paytoCNForm.controls['sCopyRequest'].disable();
      this.paytoCNForm.controls['nVendorCode'].markAsUntouched({ onlySelf: true });
      this.paytoCNForm.controls['ddCurrency'].disable();
      //if
    } else {
      if (_thisCN.paytoCNForm.get("ntype").value == "61") {
        onetime.forEach(function (value) {
          _thisCN.paytoCNForm.controls[value].enable();
        });
      }
      this.paytoCNForm.controls['ddCurrency'].enable();
      this.paytoCNForm.controls['ntype'].enable();
      this.paytoCNForm.controls['sCopyRequest'].enable();
      this.ClearInvoice();
    }
  }
  clearSubinvoice() {
    let _thisCN = this;
    this.isEdit = false;
    let FieldValid: string[] = ["nVatAmount", "sInvoiceNo", "dInvoiceDate", "ddVatType", "nTotalAmountVat"];
    for (let i = 0; i < FieldValid.length; i++) {
      _thisCN.paytoCNForm.get(FieldValid[i]).markAsUntouched();
    }
    this.paytoCNForm.patchValue({
      sInvoiceNo: null,
      nVat: null,
      dInvoiceDate: new Date(),
      nTotalAmount: null,
      nVatAmount: null,
      ddVatType: "-1",
      nTotalAmountVat: null,
      nWHTRate: null,
      nWHTRate2: null,
      ddlWithholdingTax: " ",
      ddlWithholdingTax2: " ",
      nWHTVal: null,
      _nWHTVal: null,
      nWHTVal2: null,
      _nWHTVal2: null,
      nWHTBase: null,
      nWHTBase2: null,
      nWHTOther: null,
      nWHTOther2: null,
      nTotalAmountInvoice: null,
    })
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.clear()
    this._paytoCNForm.ArrGL.reset();
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl('', Validators.required),
      sIO: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl(''),
      nline: new FormControl('')
    }))
    this.checkUseIo();
    this.checkUseGL();
    this.onWithholdingTaxSelect(1, false);
    this.onWithholdingTaxSelect(2, false);
  }
  calVat() {
    let Total: number = _ParseFloatToZero(this.paytoCNForm.value.nTotalAmountVat)
    if (Total > 0) Total = Total * -1
    let Vat: number = this.paytoCNForm.value.nVat == null ? 0 : this.paytoCNForm.value.nVat;
    let VatAmount: number = Total * Vat;
    let include = this.formatnumber(2, true, VatAmount + Total);
    this.paytoCNForm.patchValue({
      nTotalAmountInvoice: this._ConvertToDecimal(include),
      nVatAmount: this._ConvertToDecimal(VatAmount.toFixed(2)),
    })
  }
  checkUseGL() {
    let _thisCN = this;
    if (this.isUseGL) {
      _thisCN.IsNotFill_GL = false;
      _thisCN.ArrGL.controls.forEach(function (row) {
        row.get('sGL').enable();


      })
    } else {
      _thisCN.IsNotFill_GL = true;
      _thisCN.ArrGL.controls.forEach(function (row) {
        row.get('sGL').disable();
      })
    }
  }
  Check2Digit(sValue) {
    let Result: number = 0;
    if (sValue) {
      let sValueNoComma = (sValue + "").replace(/,/g, "")
      let sValueNoComma2 = Math.round(parseFloat(sValueNoComma) * 100) / 100
      Result = Number(sValueNoComma2.toFixed(2));
    }
    return Result;
  }

  onUserNoResult(event: boolean) {
    if (event == true) {
      this.paytoCNForm.patchValue({
        nContactID: null,
      });
    }
  }

  onUserSelect(sName) {
    let lstData1 = this.DataEmployee.filter(user => user.sName + " " + user.sSurName == sName)[0]
    if (lstData1 != undefined) {
      this.nComcode = lstData1.sCompCode;
      this.paytoCNForm.patchValue({
        nContactID: lstData1.sEmpCode,
        sEmail: lstData1.sEmail,
        sUnit: lstData1.sUnit,
        sTel: lstData1.sTel,
        sName: lstData1.sName + " " + lstData1.sSurName,
      });
    } else {
      this.paytoCNForm.patchValue({
        nContactID: '',
        sEmail: '',
        sUnit: '',
        sTel: '',
        sName: '',
      });
    }
  }

  async onCopyRequestCodeSelect(RequestCode) {
    let _thisCN = this;
    if (RequestCode != "") {
      let Data: any
      let lstData = this.DataRequest.filter(user => user.sRequestCode == RequestCode)[0]
      await this.http.get(this.System.SiteName + "api/_paytovendor/GetRequest/" + lstData.sRequestID + "").toPromise().then((data: any) => {
        this.ClearInvoice();
        Data = data.filter(f => f.cActive != 'N');
      })
      if (Data != null) {
        this.paytoCNForm.patchValue({ ntype: Data[0].ntype })
        let nType = Data[0].IsVendorOneTime == true ? 61 : 60;
        await this.onTypeSelect(nType);
        this.ArrRequestCN = Data;
        this.Checkinvoice();
        this.CalGrand();
      }

      this._ArrTumbon = [];

      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", Data[0].sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", Data[0].sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let ddBankKey: any = null;
      let ddBankKey2: any = null;
      let checkBank: any = [];
      if (!_IsNullOrEmpty(Data[0].sBankKey)) {
        if (_thisCN.ArrRequestCN[0].ntype === 60) {
          await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/" + _thisCN.ArrRequestCN[0].sVendorCode).toPromise().then(res => {
            if (res) {
              this.DataBankBranch = res;
            }
            else {
              this.DataBankBranch = [];
            }
          })
          if (_thisCN.ArrRequestCN[0].sValue == "Y") {
            this.DataBankBranch.push({ Show: "N/A", BANK_KEY: "N/A", NAME_OF_BANK: "N/A" })
          }
          if (this.DataBankBranch.length > 0) {
            if (_thisCN.ArrRequestCN[0].sValue == "Y" && _thisCN.ArrRequestCN[0].sBankKey === "N/A") {
              this.DataBankBranch2 = [{ Show: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
            }
            else {
              await this.http.get(this.System.SiteName + "api/Autocomplete/MT_VENDOR_BANK/*/VENDOR_CODE/" + _thisCN.ArrRequestCN[0].sVendorCode + "/BANK/" + _thisCN.ArrRequestCN[0].sBankKey + "/PARTNER_BANK/ASC").toPromise().then((data: any) => {
                if (data) {
                  this.DataBankBranch2 = data.map(m => ({ Show: m.BANK_ACCOUNT + " - " + m.ACCOUNT_HOLDER_NAME, VENDOR_CODE: m.VENDOR_CODE, BANK: m.BANK, BANK_ACCOUNT: m.BANK_ACCOUNT, ACCOUNT_HOLDER_NAME: m.ACCOUNT_HOLDER_NAME }));
                }
              })
            }
          }
        }
        checkBank = this.DataBankBranch.filter(x => x.BANK_KEY == Data[0].sBankKey);
        if (checkBank.length > 0) {
          ddBankKey = checkBank[0].NAME_OF_BANK;
        }
        ddBankKey2 = Data[0].sAccountNo;
      }
      this.paytoCNForm.patchValue({
        sAmpName: Data[0].sAmpName,
        sTumbonCode: Data[0].sTumbonCode,
        sTumbonName: Data[0].sTumbonName,
        sPostCode: Data[0].sPostCode,
        sPhoneNumber: Data[0].sPhoneNumber,
        sFaxNumber: Data[0].sFaxNumber,
        nCopyRequest: Data[0].sRequestID,
        nVendorCode: Data[0].sVendorCode,
        sTAXID: Data[0].sTAXID,
        sVendorName: Data[0].sVendorName,
        ddBank: Data[0].sPaymentType == "C" ? "" : Data[0].sBankName,
        nBankAccountNo: Data[0].sAccountNo,
        cbOffice: Data[0].nOfficeType,
        sBranch: Data[0].sVendorBranch,
        sAddressOneTime: Data[0].sAddressOneTime,
        sBankAccountName: Data[0].sPaymentType == "C" ? "" : Data[0].sAccountName,
        sInvoiceRef: Data[0].sInvoiceRef,
        sYearInvoiceRef: Data[0].sYearInvoiceRef,
        cbChequeType: Data[0].sPaymentType,
        ddBankKey: ddBankKey,
        ddBankKey2: ddBankKey2,
        nBankKey: ddBankKey != null ? Data[0].sBankKey : null,
        nBankKey2: Data[0].sBankKey2,
        BankOther: Data[0].sBankOther,
        ddApprover1: Data[0].sUserApprove1,
        sAddress: Data[0].sVendorAddress,
        sCountryID: Data[0].sCountryID,
        sProvCode: Data[0].sProvCode,
        sProvName: Data[0].sProvName,
        sAmpCode: Data[0].sAmpCode,
        sVendorEmail: Data[0].sVendorEmail,
        ddApprover2: Data[0].sUserApprove2,
        sApprove1: Data[0].nApprove1 == null ? null : Data[0].nApprove1,
        sApprove2: Data[0].nApprove2 == null ? null : Data[0].nApprove2,
        cSkipApprove1: Data[0].cSkipApprove1 == "Y" ? true : false,
      });

      this.hBranch = Data[0].nOfficeType == 2 ? false : true;
      if (this.hBranch == false) {
        this.paytoCNForm.controls['sBranch'].enable();
        this.paytoCNForm.patchValue({
          sBranch: Data[0].sVendorBranch,
          cbOffice: Data[0].nOfficeType,
        })
      }
      if (Data[0].cSkipApprove1 == "Y") {
        _thisCN.paytoCNForm.get('ddApprover1').disable();
      } else if (Data[0].cSkipApprove1 == "N") {
        _thisCN.paytoCNForm.get('ddApprover1').enable();
      }
    } this.hidBankDetail();

  }

  async onTypeSelect(type) {
    let _thisCN = this;
    let Type1 = isNullOrUndefined(type) == true ? this.paytoCNForm.value.ntype : type;
    let Fields = ["sVendorName", "sTAXID", "sAddress"];
    //AutocompleteMT_Vendor

    this.paytoCNForm.patchValue({
      sVendorName: "",
      cbOffice: 1,
      sBranch: "",
      sAddress: "",
      nVendorCode: "",
      sTAXID: "",
      ntype2: Type1,
    })
    this.paytoCNForm.controls['sBranch'].disable();
    if (Type1 == 61) {
      await this.http.get(this.System.SiteName + "api/Autocomplete/VD/" + Type1 + "/" + this.nComcode + "").toPromise().then((data: Response) => {
        this.DataVendor = data;
        if (this.DataVendor == null) {
          this.ArrVendor = [];
        } else {
          this.ArrVendor = this.DataVendor.map(re => ({ Vendor: re.VENDOR_CODE + " - " + re.sVendorName, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.sAddress, sVendorName: re.sVendorName, TAX_NUMBER1: re.TAX_NUMBER1, TAX_NUMBER2: re.TAX_NUMBER2, TAX_NUMBER3: re.TAX_NUMBER3, sValue: re.sValue }))
        }
      })
      // IsVendorOneTime
      this.IsVendorOneTime = true;
      //Vendor OneTime
      const httpOptions_VendorOT = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sComCode", this.nComcode)
      };
      let VendorOT = await this.http.get<any>(this.System.SiteName + "api/_System/GetVendorOneTime", httpOptions_VendorOT).toPromise();
      if (VendorOT) {
        this.ArrVendorName = VendorOT;
      }

      Fields.forEach(function (field) {
        _thisCN.paytoCNForm.controls[field].markAsUntouched({ onlySelf: true })
        _thisCN.paytoCNForm.controls[field].setValidators(Validators.required)
        _thisCN.paytoCNForm.controls[field].setErrors(null);
        _thisCN.paytoCNForm.controls[field].enable();
        _thisCN.paytoCNForm.controls[field].updateValueAndValidity();


      })
      let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName",]
      sfield.forEach(function (value) {
        _thisCN.paytoCNForm.controls[value].enable();
        _thisCN.paytoCNForm.controls[value].setValidators(Validators.required);
        _thisCN.paytoCNForm.controls[value].updateValueAndValidity();
      })
      let sfieldnovalidate = ["sPostCode", "sPhoneNumber", "sFaxNumber"]
      sfieldnovalidate.forEach(function (value) {
        _thisCN.paytoCNForm.controls[value].enable();
        _thisCN.paytoCNForm.controls[value].updateValueAndValidity();
      })


      _thisCN.paytoCNForm.controls["sVendorEmail"].enable();
      _thisCN.paytoCNForm.controls["sVendorEmail"].setValidators(Validators.email);
      _thisCN.paytoCNForm.controls["sVendorEmail"].updateValueAndValidity();

      this.FieldOnetimeValid.forEach(function (Item) {
        _thisCN.paytoCNForm.controls[Item._Field].setValidators(Item._Validator);
        _thisCN.paytoCNForm.controls[Item._Field].setErrors(null);
        _thisCN.paytoCNForm.controls[Item._Field].updateValueAndValidity();
        _thisCN.paytoCNForm.get(Item._Field).markAsUntouched({ onlySelf: true });
        _thisCN.paytoCNForm.controls[Item._Field].setValue(Item._Value);
      });
      this.paytoCNForm.patchValue({
        ddBankKey2: "",
        nBankKey2: "",
        ddBankKey: "",
        nBankKey: "",
      })
      this.DataBankBranch2 = [];
      this.IsLoadingBankAll = true;
      await this.http.get(this.System.SiteName + "api/Autocomplete/Bank/1/All").toPromise().then(res => {
        if (res) {
          this.DataBankBranch = res;
          this.IsLoadingBankAll = false;
        }
      })
    }
    if (Type1 == 60) {
      await this.http.get(this.System.SiteName + "api/Autocomplete/VD/10/" + this.nComcode + "").subscribe((data: Response) => {
        this.DataVendor = data;
        if (this.DataVendor == null) {
          this.ArrVendor = [];
        } else {
          this.ArrVendor = this.DataVendor.map(re => ({ Vendor: re.VENDOR_CODE + " - " + re.sVendorName, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.sAddress, sVendorName: re.sVendorName, TAX_NUMBER1: re.TAX_NUMBER1, TAX_NUMBER2: re.TAX_NUMBER2, TAX_NUMBER3: re.TAX_NUMBER3, sValue: re.sValue }))
        }
      })
      this.IsVendorOneTime = false;
      this.ArrVendorName = [];
      let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail", "sProvName", "sAmpName", "sTumbonName"]
      sfield.forEach(function (value) {
        _thisCN.paytoCNForm.controls[value].setValidators(null);
        _thisCN.paytoCNForm.controls[value].setErrors({ 'invalid': false });
        _thisCN.paytoCNForm.controls[value].markAsUntouched({ onlySelf: true });
        _thisCN.paytoCNForm.controls[value].updateValueAndValidity();
        _thisCN.paytoCNForm.controls[value].disable();
        _thisCN.paytoCNForm.controls[value].clearValidators();
      })
      Fields.forEach(function (field) {
        _thisCN.paytoCNForm.controls[field].setValue(" ");
        _thisCN.paytoCNForm.controls[field].setErrors(null);
        _thisCN.paytoCNForm.controls[field].updateValueAndValidity();
        _thisCN.paytoCNForm.controls[field].disable();
        _thisCN.paytoCNForm.controls[field].markAsUntouched({ onlySelf: true })
        _thisCN.paytoCNForm.controls[field].setValidators(null)
      })

      this.FieldOnetimeValid.forEach(function (Item) {
        _thisCN.paytoCNForm.controls[Item._Field].setErrors(null);
        _thisCN.paytoCNForm.controls[Item._Field].clearValidators();
        _thisCN.paytoCNForm.controls[Item._Field].setValue("");
      });
    }
    //GetApprover
    await this.http.get(this.System.SiteName + "api/_Paytovendor/GetApprover/" + this.nComcode + "/" + Type1 + "").toPromise().then((data: Response) => {
      if (data) {
        this.GetApprover = data[0];
      } else {
        this.GetApprover = null;
      }
      if (this.GetApprover != null) {
        if (this.GetApprover.cActive == "Y") {
          this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
          this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);

          if (this.GetApprover.IsApprover_1 == false) {
            this.paytoCNForm.controls['ddApprover1'].disable();
            this.paytoCNForm.controls['cSkipApprove1'].setValue(true);
          } else {
            let name1 = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name1ID)[0];
            let nUserId = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name1ID)[0];
            this.paytoCNForm.patchValue({
              ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
              sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
            })
          }
          if (this.GetApprover.IsApprover_2 == false) {
            this.paytoCNForm.controls['ddApprover2'].enable();
          } else {

            let name1 = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name2ID)[0];
            let nUserId = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name2ID)[0];
            this.paytoCNForm.patchValue({
              ddApprover2: isNullOrUndefined(name1) == true ? "" : name1.name1,
              sApprove2: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
            })
          }
        } else if (this.GetApprover.cActive == "N") {
          this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
          this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
        }

      }
    })
  }
}
function _ParseFloatToNull(sVal) {
  let Result1: any = null;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    Result1 = parseFloat(NoComma);
  }
  return Result1;
}

function _IsNullOrEmpty(str1) {
  var Result1 = true;
  if (str1 && str1 != "null") {
    Result1 = false;
  }
  return Result1;
}
function _ParseFloatToZero(sVal) {
  let Result1: any = 0;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    Result1 = parseFloat(NoComma);
  }
  return Result1;
}


